var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaspIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.08410658 0.08733973 4.16734669 0.19552278 6.25 0.3125 C7.99023438 0.39951172 7.99023438 0.39951172 9.765625 0.48828125 C13.15014039 1.0237541 14.60454488 1.59884142 17 4 C17.33 4.99 17.66 5.98 18 7 C18.66 7.66 19.32 8.32 20 9 C19.34 9 18.68 9 18 9 C18.33 9.66 18.66 10.32 19 11 C19.36117679 14.34267919 19.46720359 17.70468518 19.625 21.0625 C19.6765625 21.99900391 19.728125 22.93550781 19.78125 23.90039062 C19.82507813 24.79048828 19.86890625 25.68058594 19.9140625 26.59765625 C19.9752124 27.82754272 19.9752124 27.82754272 20.03759766 29.08227539 C20 31 20 31 19 32 C18.75960934 33.76368639 18.57864569 35.53551724 18.421875 37.30859375 C13.37884078 90.87358788 -2.73877058 140.26760924 -29.77587891 186.74536133 C-31.11626264 189.05753784 -31.11626264 189.05753784 -32 192 C-32.66 192 -33.32 192 -34 192 C-34.22945312 192.67417969 -34.45890625 193.34835937 -34.6953125 194.04296875 C-36.35040384 197.79417877 -38.52908791 200.96213296 -40.875 204.3125 C-41.3604126 205.01036621 -41.8458252 205.70823242 -42.34594727 206.42724609 C-53.71259015 222.66114841 -66.02630532 237.78239726 -79.52734375 252.28125 C-81.27569461 254.20360735 -82.94088149 256.12447337 -84.58203125 258.1328125 C-86.55070027 260.46722778 -88.42628559 262.41871052 -90.75 264.375 C-92.81698681 266.12984516 -94.86847246 267.87681459 -96.84765625 269.73046875 C-102.13031657 274.65605064 -107.82548812 278.95950239 -113.625 283.25 C-114.43686768 283.85271729 -115.24873535 284.45543457 -116.08520508 285.07641602 C-119.62326673 287.66810487 -123.13124522 290.15319831 -126.9609375 292.296875 C-130.00066691 293.81989435 -130.00066691 293.81989435 -132 296 C-133.25272843 296.69245054 -134.53174191 297.33804787 -135.82421875 297.953125 C-136.59773682 298.32203857 -137.37125488 298.69095215 -138.16821289 299.07104492 C-138.99957764 299.4601001 -139.83094238 299.84915527 -140.6875 300.25 C-141.54529053 300.65259033 -142.40308105 301.05518066 -143.28686523 301.4699707 C-150.75188363 304.9406042 -158.27172798 308.15429556 -166 311 C-166.66757324 311.2484668 -167.33514648 311.49693359 -168.02294922 311.75292969 C-196.36649818 322.16161488 -226.49785391 325.55718836 -256.4375 327.75 C-257.30484772 327.8151178 -258.17219543 327.8802356 -259.06582642 327.94732666 C-272.05994012 328.90513282 -284.97294791 329.14789463 -298 329 C-297.34 332.63 -296.68 336.26 -296 340 C-294.72769531 340.21914063 -293.45539063 340.43828125 -292.14453125 340.6640625 C-250.61869546 348.05192351 -213.81217841 363.78155495 -183 393 C-182.52852539 393.44424316 -182.05705078 393.88848633 -181.57128906 394.34619141 C-166.45397357 408.68157679 -153.79150747 426.0628429 -145 445 C-145 445.66 -145 446.32 -145 447 C-144.34 447.33 -143.68 447.66 -143 448 C-142.0703125 449.88598633 -142.0703125 449.88598633 -141.125 452.33203125 C-140.77953125 453.21310547 -140.4340625 454.09417969 -140.078125 455.00195312 C-139.72234375 455.92943359 -139.3665625 456.85691406 -139 457.8125 C-138.29316323 459.63209248 -137.5848807 461.45112415 -136.875 463.26953125 C-136.56304688 464.08010986 -136.25109375 464.89068848 -135.9296875 465.72583008 C-135.04185699 467.99340081 -135.04185699 467.99340081 -133.9375 470.05737305 C-132.67871379 472.66574854 -132.2162645 475.37414295 -131.62890625 478.1953125 C-130.87514609 481.5568019 -129.97096588 484.86451832 -129.0625 488.1875 C-128.36801429 490.7898887 -127.68365465 493.39472147 -127 496 C-126.71769531 497.05574219 -126.43539062 498.11148437 -126.14453125 499.19921875 C-113.66394288 550.70540325 -129.43502262 606.66702598 -156.37573242 650.96777344 C-161.57409289 659.20693663 -167.57608901 666.69171099 -174 674 C-174.4729248 674.54060059 -174.94584961 675.08120117 -175.43310547 675.63818359 C-180.77397854 681.69951522 -186.39325629 687.49687783 -192.0625 693.25 C-192.62324219 693.82387451 -193.18398438 694.39774902 -193.76171875 694.98901367 C-195.13574292 696.36578758 -196.56361106 697.68842247 -198 699 C-198.66 699 -199.32 699 -200 699 C-200 699.66 -200 700.32 -200 701 C-201.65002828 702.35386936 -203.3174387 703.68678142 -205 705 C-205.33 705.66 -205.66 706.32 -206 707 C-207.66086499 708.00960649 -209.32920322 709.00691597 -211 710 C-213.60218703 711.86420999 -216.14126473 713.81034043 -218.6875 715.75 C-233.38800737 726.8379941 -248.65108999 736.16709354 -264.6875 745.1875 C-265.72011963 745.76959229 -266.75273926 746.35168457 -267.81665039 746.95141602 C-287.57713163 758 -287.57713163 758 -291 758 C-291.33 758.66 -291.66 759.32 -292 760 C-293.93920898 761.01806641 -293.93920898 761.01806641 -296.49609375 762.1015625 C-297.4389624 762.50560303 -298.38183105 762.90964355 -299.35327148 763.32592773 C-300.37106689 763.75462158 -301.3888623 764.18331543 -302.4375 764.625 C-304.54197559 765.52401677 -306.64613866 766.42376545 -308.75 767.32421875 C-310.32974609 767.99783447 -310.32974609 767.99783447 -311.94140625 768.68505859 C-317.00830296 770.86340356 -322.03751558 773.12529287 -327.06225586 775.39892578 C-339.54666847 781 -339.54666847 781 -344 781 C-343.37763647 777.52579346 -342.02565332 775.3831718 -339.9375 772.5625 C-328.4000388 756.41473483 -318.93789718 738.87977385 -311.9375 720.3125 C-311.38267944 718.8442981 -311.38267944 718.8442981 -310.81665039 717.34643555 C-308.86293515 711.97360391 -307.38277567 706.71625353 -306.39672852 701.08276367 C-306 699 -306 699 -305 696 C-302.07292132 684.15447847 -301.82111871 672.1440517 -302 660 C-302.66 660 -303.32 660 -304 660 C-304 659.34 -304 658.68 -304 658 C-303.34 658 -302.68 658 -302 658 C-303.68632684 637.9018907 -306.82323964 617.88446191 -314.21826172 599.00292969 C-315.1323269 596.6609588 -315.98314131 594.29995672 -316.83203125 591.93359375 C-320.29441423 582.31963208 -323.8099364 572.74875162 -327.67578125 563.2890625 C-331.81954091 552.99689249 -335.4031506 542.49276981 -339 532 C-339.26748047 531.22720703 -339.53496094 530.45441406 -339.81054688 529.65820312 C-346.57173267 509.95958293 -352.24826285 488.96796498 -352.0625 468.0625 C-352.05798828 467.09248047 -352.05347656 466.12246094 -352.04882812 465.12304688 C-352.0371315 462.7486324 -352.02074086 460.37434979 -352 458 C-352.66 458 -353.32 458 -354 458 C-354 457.34 -354 456.68 -354 456 C-353.34 456 -352.68 456 -352 456 C-352 451.71 -352 447.42 -352 443 C-351.34 443 -350.68 443 -350 443 C-349.896875 441.845 -349.79375 440.69 -349.6875 439.5 C-349.13964887 434.98828481 -347.7225121 431.19394251 -346 427 C-349.63 426.67 -353.26 426.34 -357 426 C-357 425.34 -357 424.68 -357 424 C-358.65 424.33 -360.3 424.66 -362 425 C-362 424.34 -362 423.68 -362 423 C-362.59167969 422.93941406 -363.18335938 422.87882812 -363.79296875 422.81640625 C-364.97826172 422.69072266 -364.97826172 422.69072266 -366.1875 422.5625 C-366.96480469 422.48128906 -367.74210937 422.40007812 -368.54296875 422.31640625 C-371.06001996 421.99227088 -373.5177143 421.52467495 -376 421 C-375.75765625 422.24007813 -375.5153125 423.48015625 -375.265625 424.7578125 C-370.62269857 449.03722867 -367.83650198 473.38814239 -365.75 498 C-365.66105469 499.04735321 -365.57210938 500.09470642 -365.48046875 501.17379761 C-365.22758195 504.17803735 -364.97961892 507.18262744 -364.734375 510.1875 C-364.65958923 511.08940567 -364.58480347 511.99131134 -364.50775146 512.92054749 C-363.87588612 520.84801935 -363.55797078 526.05711214 -367.875 533 C-373.75816612 542.95921637 -378.41379218 553.3946492 -383 564 C-383.46647949 565.04293213 -383.46647949 565.04293213 -383.94238281 566.10693359 C-390.60432447 581.09438135 -393.21412229 597.80977968 -394.6953125 614.05078125 C-394.80270752 615.17685791 -394.91010254 616.30293457 -395.02075195 617.46313477 C-395.20997664 619.59496071 -395.36677016 621.73001001 -395.48510742 623.86694336 C-395.56865479 624.8338208 -395.65220215 625.80069824 -395.73828125 626.796875 C-395.79024658 627.63573242 -395.84221191 628.47458984 -395.89575195 629.33886719 C-397.40000305 632.96396933 -399.78891472 634.68507476 -402.78260803 637.15267944 C-406.31559781 640.09603124 -409.50959038 643.36680613 -412.75390625 646.62109375 C-413.45845444 647.32468521 -414.16300262 648.02827667 -414.88890076 648.75318909 C-416.36653367 650.23014648 -417.84292457 651.70834742 -419.31811523 653.18774414 C-421.55666481 655.43165085 -423.80050473 657.67016704 -426.04492188 659.90820312 C-427.48990404 661.35384618 -428.93457592 662.79979945 -430.37890625 664.24609375 C-431.03951553 664.9046788 -431.70012482 665.56326385 -432.38075256 666.24180603 C-436.21315992 670.09325754 -439.86739264 674.04930275 -443.40861511 678.17050171 C-446.09742454 681.26162836 -448.93341331 684.21329996 -451.75 687.1875 C-460.02419068 695.99497297 -468.22942851 704.96087676 -475 715 C-476.98 713.515 -476.98 713.515 -479 712 C-478.31164062 710.49566406 -478.31164062 710.49566406 -477.609375 708.9609375 C-476.02187118 705.25614229 -475.1116516 701.56746249 -474.25 697.625 C-469.91490303 679.37701794 -460.92990128 663.95318846 -450.68359375 648.4296875 C-450.30452881 647.85441818 -449.92546387 647.27914886 -449.53491211 646.68644714 C-447.63717486 643.80971965 -445.72924965 640.94078145 -443.80126953 638.08422852 C-438.26291551 629.77290842 -435.22831115 622.02993238 -432.5 612.5 C-428.21083649 597.82639427 -423.03663967 583.42958275 -418 569 C-418.66 568.67 -419.32 568.34 -420 568 C-419.01 568 -418.02 568 -417 568 C-416.83491943 567.42169434 -416.66983887 566.84338867 -416.49975586 566.24755859 C-414.46151699 559.26698653 -412.06214628 552.45208066 -409.5625 545.625 C-408.40724239 542.46119163 -407.25649407 539.29631097 -406.12402344 536.12426758 C-405.38371611 534.06655409 -404.62179793 532.01646821 -403.83691406 529.9753418 C-401.15317572 522.67855543 -400.43288259 516.30903426 -400.625 508.5625 C-400.63789063 507.47590088 -400.65078125 506.38930176 -400.6640625 505.26977539 C-400.80885881 497.71265254 -401.35335308 490.39520891 -403 483 C-404.68838564 484.37391236 -406.37565901 485.74919161 -408.0625 487.125 C-409.47208984 488.27355469 -409.47208984 488.27355469 -410.91015625 489.4453125 C-413.08001152 491.22207804 -415.19888508 493.0469379 -417.30859375 494.89453125 C-421.35574634 498.37573784 -425.6544312 501.46737591 -430 504.5625 C-430.76828125 505.11357422 -431.5365625 505.66464844 -432.328125 506.23242188 C-433.08609375 506.77576172 -433.8440625 507.31910156 -434.625 507.87890625 C-435.72847778 508.67458008 -435.72847778 508.67458008 -436.85424805 509.48632812 C-438.23691194 510.4616969 -439.6386695 511.41080553 -441.06176758 512.32617188 C-443.88036943 514.170626 -445.76314963 515.48926727 -447.19921875 518.5859375 C-447.44091797 519.96652344 -447.44091797 519.96652344 -447.6875 521.375 C-447.90148437 522.42945313 -448.11546875 523.48390625 -448.3359375 524.5703125 C-448.55507813 525.70210937 -448.77421875 526.83390625 -449 528 C-460.31905171 575.24925256 -491.69074937 608.29766883 -532.140625 633.62109375 C-533.50794778 634.45976765 -534.87768566 635.29451891 -536.25 636.125 C-536.89453125 636.51582764 -537.5390625 636.90665527 -538.203125 637.30932617 C-542.74612307 640 -542.74612307 640 -545 640 C-544.44098328 635.90054407 -542.07796724 633.24176664 -539.5625 630.125 C-538.64273206 628.95453659 -537.72481708 627.78261515 -536.80859375 626.609375 C-536.33921387 626.00931641 -535.86983398 625.40925781 -535.38623047 624.79101562 C-511.10280028 593.41672118 -495.17421761 558.65862253 -481.56884766 521.61376953 C-479.03210105 514.72598864 -476.4538457 507.86174314 -473.6875 501.0625 C-473.38626221 500.29357422 -473.08502441 499.52464844 -472.7746582 498.73242188 C-469.83447583 491.66369636 -464.85618379 488.82202816 -458.5 484.875 C-434.76210055 469.79670131 -420.95577037 452.96167926 -410 427 C-411.01578125 426.96261719 -412.0315625 426.92523437 -413.078125 426.88671875 C-421.71806344 426.49830046 -429.66721696 425.50930398 -438 423 C-438.24492187 423.87011719 -438.48984375 424.74023438 -438.7421875 425.63671875 C-440.9423621 431.5197943 -445.11144118 436.13930147 -449 441 C-449.65484375 441.82371094 -450.3096875 442.64742187 -450.984375 443.49609375 C-465.24529065 460.49722666 -487.36219923 469.42388721 -508 476 C-508.66 476 -509.32 476 -510 476 C-510.38285156 477.25103516 -510.38285156 477.25103516 -510.7734375 478.52734375 C-516.40557061 494.4730964 -525.99500195 509.31075877 -537 522 C-537.75152344 522.88558594 -538.50304687 523.77117188 -539.27734375 524.68359375 C-543.31350388 529.36203614 -543.31350388 529.36203614 -545 531 C-545.66 531 -546.32 531 -547 531 C-547 531.66 -547 532.32 -547 533 C-548.375 534.625 -548.375 534.625 -550 536 C-550.66 536 -551.32 536 -552 536 C-552 536.66 -552 537.32 -552 538 C-553.50787161 539.37491299 -555.08539761 540.67364462 -556.6875 541.9375 C-560.38298666 544.88823297 -564.03170883 547.86397728 -567.61108398 550.95410156 C-575.4451394 557.70471088 -583.66557273 563.88424864 -592 570 C-593.02609375 570.75539063 -594.0521875 571.51078125 -595.109375 572.2890625 C-597.73002477 574.20643055 -600.36152038 576.10726578 -603 578 C-604.39798828 579.01126953 -604.39798828 579.01126953 -605.82421875 580.04296875 C-606.72785156 580.68878906 -607.63148438 581.33460938 -608.5625 582 C-609.77099609 582.86625 -609.77099609 582.86625 -611.00390625 583.75 C-613 585 -613 585 -615 585 C-614.38220313 581.79308481 -613.29559456 579.69084751 -611.40234375 577.04296875 C-610.85578125 576.27130371 -610.30921875 575.49963867 -609.74609375 574.70458984 C-609.14925781 573.8739502 -608.55242187 573.04331055 -607.9375 572.1875 C-606.66498206 570.39219815 -605.39286291 568.5966136 -604.12109375 566.80078125 C-603.45062012 565.85799316 -602.78014648 564.91520508 -602.08935547 563.94384766 C-598.53603649 558.93731339 -595.01555876 553.90808979 -591.5 548.875 C-590.84249756 547.94067139 -590.18499512 547.00634277 -589.50756836 546.04370117 C-581.91625203 536.69647596 -581.91625203 536.69647596 -578 526 C-576.66881662 524.66452017 -575.33512264 523.33154162 -574 522 C-572.95834166 520.41643848 -571.97586857 518.79280239 -571.046875 517.140625 C-570.51416992 516.19783691 -569.98146484 515.25504883 -569.43261719 514.28369141 C-568.87735352 513.28257324 -568.32208984 512.28145508 -567.75 511.25 C-567.1715332 510.21665527 -566.59306641 509.18331055 -565.99707031 508.11865234 C-562.10081206 501.1112678 -558.41243081 494.03104523 -554.89453125 486.828125 C-552.481208 481.9019337 -549.88965044 477.07101325 -547.28857422 472.24194336 C-545.4710485 468.85108998 -543.72083029 465.45661526 -542.12109375 461.95703125 C-537.34949014 451.58786839 -537.34949014 451.58786839 -533.1875 449.125 C-530 448 -530 448 -528 448 C-527.67 447.34 -527.34 446.68 -527 446 C-524.67590336 445.04978341 -522.36958725 444.19609469 -520 443.375 C-493.55549753 434.22838712 -493.55549753 434.22838712 -474 416 C-473.34 416 -472.68 416 -472 416 C-471.11234293 413.59525631 -470.78760659 412.46995645 -471.86328125 410.08984375 C-472.34152344 409.37957031 -472.81976563 408.66929687 -473.3125 407.9375 C-476.58308756 402.80460141 -479.43576351 397.51627524 -482.25 392.125 C-482.68610596 391.29218506 -483.12221191 390.45937012 -483.5715332 389.60131836 C-484.71943672 387.40341877 -485.86519418 385.20469019 -487 383 C-487.37479492 382.31534668 -487.74958984 381.63069336 -488.13574219 380.92529297 C-489 379 -489 379 -489 376 C-489.66 375.67 -490.32 375.34 -491 375 C-491.8515625 372.71484375 -491.8515625 372.71484375 -492.625 369.9375 C-492.88539063 369.01839844 -493.14578125 368.09929687 -493.4140625 367.15234375 C-493.70410156 366.08693359 -493.70410156 366.08693359 -494 365 C-496.16674021 364.77048667 -496.16674021 364.77048667 -497.77734375 366.6875 C-498.49019531 367.450625 -499.20304687 368.21375 -499.9375 369 C-511.62151723 380.90763479 -526.44879462 388.91690639 -541.3125 396.171875 C-545.03238585 397.99393721 -548.63551904 399.98495623 -552.203125 402.08984375 C-554 403 -554 403 -555.8125 403.4375 C-558.9681148 404.24894381 -561.81889646 405.66842461 -564.75 407.0625 C-565.40105713 407.37195557 -566.05211426 407.68141113 -566.72290039 408.00024414 C-568.10604674 408.66005593 -569.48826792 409.32181011 -570.86962891 409.98535156 C-572.99199379 410.99618682 -575.12565725 411.97943759 -577.26171875 412.9609375 C-585.12075338 416.63578923 -591.4788153 420.11599123 -597 427 C-597.79664063 427.95777344 -598.59328125 428.91554688 -599.4140625 429.90234375 C-606.46238835 438.58358975 -612.08660064 447.95209831 -617 458 C-623.05893707 453.71441036 -626.21485895 448.29259735 -630 442 C-630.65226563 440.98421875 -631.30453125 439.9684375 -631.9765625 438.921875 C-654.47783777 403.64960566 -659.63297936 363.76004131 -653 323 C-652.81050781 321.74832031 -652.62101562 320.49664062 -652.42578125 319.20703125 C-651.55469069 313.82020723 -651.55469069 313.82020723 -651 312 C-650.34 311.67 -649.68 311.34 -649 311 C-648.43932279 309.16841739 -648.43932279 309.16841739 -648.09765625 306.97265625 C-647.11331983 302.13881018 -645.48659313 297.91070331 -643.4375 293.4375 C-643.08671387 292.66519043 -642.73592773 291.89288086 -642.37451172 291.09716797 C-635.88298655 277.05562324 -628.43544408 265.46762922 -618.1484375 253.921875 C-616.79456759 252.09875112 -616.79456759 252.09875112 -617.21875 250.11206055 C-618.17175337 247.5356755 -619.40713818 246.22023966 -621.3515625 244.28515625 C-622.03863281 243.59873047 -622.72570312 242.91230469 -623.43359375 242.20507812 C-624.15675781 241.49802734 -624.87992188 240.79097656 -625.625 240.0625 C-626.32496094 239.35931641 -627.02492188 238.65613281 -627.74609375 237.93164062 C-631.01224723 234.69881524 -634.23070622 231.72632755 -638.0234375 229.12109375 C-639.00570312 228.42113281 -639.98796875 227.72117187 -641 227 C-641 226.34 -641 225.68 -641 225 C-641.85368164 224.60361328 -641.85368164 224.60361328 -642.72460938 224.19921875 C-645.14694553 222.92255403 -647.21780114 221.45712967 -649.40625 219.8125 C-650.23253906 219.19632813 -651.05882812 218.58015625 -651.91015625 217.9453125 C-653.63671875 216.6484375 -655.36328125 215.3515625 -657.08984375 214.0546875 C-657.91613281 213.43851563 -658.74242187 212.82234375 -659.59375 212.1875 C-660.34333984 211.62417969 -661.09292969 211.06085938 -661.86523438 210.48046875 C-663.85162425 209.10289919 -665.81093103 208.01644199 -668 207 C-668 206.34 -668 205.68 -668 205 C-668.9590625 204.6596875 -668.9590625 204.6596875 -669.9375 204.3125 C-673.44447326 202.80951146 -676.6945962 200.99986736 -680.01171875 199.12109375 C-682.35763212 197.79834888 -684.42749536 196.85750155 -687 196 C-687 195.34 -687 194.68 -687 194 C-687.63679688 193.75378906 -688.27359375 193.50757813 -688.9296875 193.25390625 C-691.35696652 192.26261291 -693.74279832 191.22779676 -696.1328125 190.15234375 C-717.01376744 180.8306027 -738.32237553 173.98433701 -760.67578125 169.19140625 C-764.55149993 168.35654337 -768.27408267 167.3787818 -772 166 C-766.73189406 159.73758267 -756.06378096 159.75030217 -748.375 158.8125 C-747.69550293 158.72863037 -747.01600586 158.64476074 -746.31591797 158.55834961 C-735.9943511 157.41466177 -725.97061766 158.27721152 -715.68359375 159.37695312 C-714.74902344 159.47041016 -713.81445312 159.56386719 -712.8515625 159.66015625 C-711.59593506 159.79369507 -711.59593506 159.79369507 -710.31494141 159.92993164 C-707.99443305 160.0001685 -706.20898813 159.67858844 -704 159 C-704.33 159.99 -704.66 160.98 -705 162 C-703.84757812 162.11730469 -702.69515625 162.23460937 -701.5078125 162.35546875 C-680.35502297 165.04249489 -659.98886499 177.45949649 -644 191 C-642.92976165 191.8714845 -641.85811077 192.74123679 -640.78515625 193.609375 C-634.81655879 198.48922652 -629.1672203 203.63923286 -623.6875 209.0625 C-623.11773438 209.62300049 -622.54796875 210.18350098 -621.9609375 210.76098633 C-618 214.75325258 -618 214.75325258 -618 217 C-617.34 217 -616.68 217 -616 217 C-614.71899414 218.43701172 -614.71899414 218.43701172 -613.28515625 220.4296875 C-612.76373047 221.14253906 -612.24230469 221.85539063 -611.70507812 222.58984375 C-611.16302734 223.34394531 -610.62097656 224.09804688 -610.0625 224.875 C-608.99542559 226.3548469 -607.92397517 227.83155064 -606.84765625 229.3046875 C-606.37336182 229.96452637 -605.89906738 230.62436523 -605.41040039 231.30419922 C-603.92161318 233.25810002 -603.92161318 233.25810002 -601 235 C-600.26394531 234.52949219 -599.52789063 234.05898438 -598.76953125 233.57421875 C-597.79371094 232.95160156 -596.81789063 232.32898438 -595.8125 231.6875 C-594.84957031 231.07261719 -593.88664063 230.45773437 -592.89453125 229.82421875 C-590.28365697 228.17876897 -587.6530398 226.57630335 -585 225 C-585.63581031 218.16503913 -587.34055454 211.32764609 -590 205 C-590.99 204.67 -591.98 204.34 -593 204 C-593.70074844 200.846632 -594 198.27275026 -594 195 C-595.06841148 192.59482369 -595.06841148 192.59482369 -596.5 190.25 C-596.9640625 189.45078125 -597.428125 188.6515625 -597.90625 187.828125 C-598.44765625 186.92320312 -598.44765625 186.92320312 -599 186 C-599.99 186 -600.98 186 -602 186 C-601.67 185.01 -601.34 184.02 -601 183 C-603.93337234 177.90219759 -607.8003229 173.57125733 -611.640625 169.1484375 C-615 165.20917039 -615 165.20917039 -615 163 C-615.66 163 -616.32 163 -617 163 C-618.35386936 161.34997172 -619.68678142 159.6825613 -621 158 C-621.66 157.67 -622.32 157.34 -623 157 C-623 156.34 -623 155.68 -623 155 C-623.87398437 154.61134766 -623.87398437 154.61134766 -624.765625 154.21484375 C-627.1680479 152.9086313 -628.78166008 151.456043 -630.75 149.5625 C-646.2317634 135.55519026 -664.95419828 126.11929869 -684 118 C-683.505 116.515 -683.505 116.515 -683 115 C-654.60352348 111.37955829 -624.67329796 120.3655737 -601.8125 137.37109375 C-596.36698594 141.71222422 -596.36698594 141.71222422 -594 144 C-594 144.66 -594 145.32 -594 146 C-593.43152344 146.22429687 -592.86304688 146.44859375 -592.27734375 146.6796875 C-589.33201689 148.38726979 -587.69267994 150.4742735 -585.5625 153.125 C-584.77617188 154.10339844 -583.98984375 155.08179688 -583.1796875 156.08984375 C-581.3266412 158.56389302 -579.72739467 161.01420459 -578.1875 163.6875 C-577.465625 164.780625 -576.74375 165.87375 -576 167 C-574.68 167 -573.36 167 -572 167 C-572.185625 168.36125 -572.185625 168.36125 -572.375 169.75 C-572.38266598 173.58299127 -571.08874746 176.13830405 -569.3125 179.5 C-563.20128459 191.07383484 -560.23117112 203.21158015 -558 216 C-557.46221924 215.82871582 -556.92443848 215.65743164 -556.37036133 215.48095703 C-536.11019308 209.07845854 -518.22245133 204.50015077 -498 214 C-489.49022491 219.10586505 -481.82778305 225.73649497 -476.1875 233.9375 C-474.28872491 237.23052042 -474.28872491 237.23052042 -471 238 C-471 238.99 -471 239.98 -471 241 C-469.56009377 243.17032476 -469.56009377 243.17032476 -468 245 C-462.690282 244.36587763 -458.18079673 242.62759324 -453.25 240.6875 C-432.42743169 232.8503792 -410.89251349 229.1299951 -389.421875 236.9375 C-388.62265625 237.22625 -387.8234375 237.515 -387 237.8125 C-386.319375 238.08707031 -385.63875 238.36164063 -384.9375 238.64453125 C-382.33546524 239.12192069 -381.19563221 238.39427277 -379 237 C-378.46375 236.46375 -377.9275 235.9275 -377.375 235.375 C-376.92125 234.92125 -376.4675 234.4675 -376 234 C-375.34 234 -374.68 234 -374 234 C-374 233.34 -374 232.68 -374 232 C-372.57008411 230.73376779 -371.07605731 229.53996684 -369.5625 228.375 C-364.34740641 224.20695223 -359.46658693 219.78269298 -354.625 215.1875 C-353.90175537 214.50212158 -353.17851074 213.81674316 -352.43334961 213.1105957 C-350.98615328 211.73751499 -349.53961202 210.36374349 -348.09375 208.98925781 C-344.94888721 206.0013448 -341.79459687 203.02415748 -338.625 200.0625 C-338.09600098 199.56065186 -337.56700195 199.05880371 -337.02197266 198.54174805 C-334.67408868 196.35428091 -333.08753731 195.0291791 -330 194 C-330 193.34 -330 192.68 -330 192 C-328.38281689 190.5671282 -326.70376628 189.20375251 -325 187.875 C-320.69247005 184.43338836 -316.75630358 180.87079833 -312.9140625 176.92578125 C-304.55915066 168.51971689 -304.55915066 168.51971689 -300 167 C-300 166.34 -300 165.68 -300 165 C-298.48848454 163.64902626 -296.91186687 162.37072655 -295.3125 161.125 C-290.78932233 157.51229422 -286.4800383 153.76340496 -282.25 149.8125 C-281.15504163 148.7928681 -280.0599925 147.77333366 -278.96484375 146.75390625 C-278.20083252 146.04258545 -278.20083252 146.04258545 -277.42138672 145.31689453 C-269.52391546 138 -269.52391546 138 -267 138 C-267 137.34 -267 136.68 -267 136 C-264.97266938 134.276617 -262.93476844 132.66181447 -260.8125 131.0625 C-255.97161162 127.34624386 -251.24060791 123.5548483 -246.625 119.5625 C-241.07710182 114.78394264 -235.29080976 110.37774731 -229.37939453 106.05883789 C-226.67145547 104.06882546 -224.16227085 102.16284324 -221.78515625 99.77734375 C-220 98 -220 98 -218.3046875 97.16674805 C-215.13656136 95.56288419 -212.26713042 93.55286384 -209.33984375 91.5546875 C-207.98852577 90.64030594 -206.6368673 89.72642743 -205.28491211 88.81298828 C-204.22166214 88.09372162 -204.22166214 88.09372162 -203.13693237 87.35992432 C-183.52879774 74.12169237 -163.62180204 61.12230371 -142.16992188 51.03417969 C-139.6555656 49.83584337 -137.16453348 48.59439327 -134.671875 47.3515625 C-122.40070989 41.28237906 -109.96906231 35.76766081 -97.3125 30.5625 C-96.60192444 30.26954041 -95.89134888 29.97658081 -95.15924072 29.67474365 C-69.19448113 19 -69.19448113 19 -65 19 C-64.67 18.34 -64.34 17.68 -64 17 C-61.17200849 16.3556475 -58.33881851 15.97673669 -55.46875 15.5625 C-54.6540625 15.376875 -53.839375 15.19125 -53 15 C-52.67 14.34 -52.34 13.68 -52 13 C-50.34765625 12.54296875 -50.34765625 12.54296875 -48.0625 12.1875 C-43.10459865 11.29183361 -38.33594521 10.01337924 -33.5 8.625 C-27.11775816 6.81439672 -20.72073303 5.15264737 -14.25 3.6875 C-13.51201172 3.51621582 -12.77402344 3.34493164 -12.01367188 3.16845703 C-7.93793564 2.26763308 -4.17197208 1.82288798 0 2 C0 1.34 0 0.68 0 0 Z M-15 33 C-15.76183594 33.25394531 -16.52367187 33.50789063 -17.30859375 33.76953125 C-27 37 -27 37 -28.98779297 37.65234375 C-55.29384165 46.32375124 -80.43420386 57.16043582 -105.25 69.4375 C-106.20737061 69.90913574 -107.16474121 70.38077148 -108.15112305 70.86669922 C-110.79514424 72.19801726 -113.39836685 73.5879895 -116 75 C-116.81017578 75.39783691 -117.62035156 75.79567383 -118.45507812 76.20556641 C-125.97810337 80.3764847 -128.12971163 86.73390036 -131 94.5 C-131.50139965 95.793794 -132.00558288 97.08651247 -132.51245117 98.37817383 C-133.53301206 100.98659896 -134.53953837 103.59980216 -135.53662109 106.21728516 C-136.89131342 109.75049804 -138.33096546 113.24338176 -139.80078125 116.73046875 C-140.22681641 117.74238281 -140.65285156 118.75429687 -141.09179688 119.796875 C-141.89122671 121.68992484 -142.69321455 123.58189696 -143.49804688 125.47265625 C-143.84544922 126.31054688 -144.19285156 127.1484375 -144.55078125 128.01171875 C-145.00964722 129.10166138 -145.00964722 129.10166138 -145.4777832 130.21362305 C-146.24329086 132.08026394 -146.24329086 132.08026394 -145 134 C-144.11183594 133.5875 -143.22367188 133.175 -142.30859375 132.75 C-130.47452436 127.35980289 -118.31887386 123.13534523 -106 119 C-104.92363281 118.63664551 -103.84726562 118.27329102 -102.73828125 117.89892578 C-75.43502519 108.68609633 -75.43502519 108.68609633 -69 109 C-70.98 109.99 -70.98 109.99 -73 111 C-73 111.66 -73 112.32 -73 113 C-73.85722656 113.24621094 -74.71445312 113.49242187 -75.59765625 113.74609375 C-79.30035086 115.11069188 -82.15799327 116.87229939 -85.4375 119.0625 C-86.67981044 119.87940019 -87.92334042 120.69444821 -89.16796875 121.5078125 C-89.8026709 121.92321289 -90.43737305 122.33861328 -91.09130859 122.76660156 C-109.61001812 134.73341156 -129.11912918 144.7104965 -149.09912109 153.97314453 C-161.42755259 159.71774148 -172.7638167 166.92551081 -184.21923828 174.23144531 C-187.94153321 176.59881181 -191.68899889 178.92447497 -195.4375 181.25 C-201.5714587 185.07000235 -207.63130892 188.99826659 -213.68359375 192.94604492 C-219.15917999 196.49971563 -224.72042354 199.88959276 -230.35571289 203.18383789 C-232.83386222 204.64207678 -234.9569359 205.9569359 -237 208 C-236.21625 207.835 -235.4325 207.67 -234.625 207.5 C-231.8464781 207.1167556 -229.66144869 207.00462627 -226.91015625 207.09765625 C-218.82440873 207.12849546 -210.81922825 205.95702213 -202.8125 204.9375 C-201.94129517 204.82740601 -201.07009033 204.71731201 -200.17248535 204.60388184 C-158.89218871 199.34015247 -118.18499369 191.23454873 -79 177 C-78.01435059 176.65050293 -77.02870117 176.30100586 -76.01318359 175.94091797 C-73.22711703 174.94579394 -70.45576702 173.91849086 -67.6875 172.875 C-66.88699219 172.58681396 -66.08648438 172.29862793 -65.26171875 172.00170898 C-50.32612629 166.13021902 -42.66159874 145.44461981 -36.44726562 131.52099609 C-27.58488697 110.10358101 -15.09095467 79.70009934 -17 56 C-17.33 55.67 -17.66 55.34 -18 55 C-17.01 54.505 -17.01 54.505 -16 54 C-15.49381958 51.02211985 -15.1105949 48.12443547 -14.8125 45.125 C-14.71775391 44.29613281 -14.62300781 43.46726562 -14.52539062 42.61328125 C-13.97664791 37.74916479 -13.97664791 37.74916479 -15 33 Z M-159.6875 97.875 C-160.8321875 98.62438843 -160.8321875 98.62438843 -162 99.38891602 C-164.33651616 100.92116495 -166.66846995 102.46017799 -169 104 C-170.28771012 104.84512872 -171.57546715 105.69018598 -172.86328125 106.53515625 C-181.69657296 112.35565191 -190.35227895 118.4158439 -198.96728516 124.55371094 C-200.88501997 125.918191 -202.80698653 127.27645161 -204.73046875 128.6328125 C-212.07659001 133.82560385 -219.27208667 139.18201091 -226.36132812 144.72021484 C-228.01417185 146.01106806 -229.67101604 147.29665998 -231.328125 148.58203125 C-240.05291331 155.37215445 -248.58711481 162.38356217 -257.10205078 169.43408203 C-259.59702721 171.492582 -262.11132076 173.52690537 -264.625 175.5625 C-269.83819802 179.81326146 -274.90794371 184.22416485 -279.96337891 188.66040039 C-280.57358887 189.1939917 -281.18379883 189.72758301 -281.8125 190.27734375 C-282.35519531 190.75421631 -282.89789062 191.23108887 -283.45703125 191.72241211 C-285 193 -285 193 -288 195 C-288 195.66 -288 196.32 -288 197 C-288.56589844 197.24621094 -289.13179687 197.49242187 -289.71484375 197.74609375 C-292.39248258 199.21536224 -294.33043612 200.97752435 -296.5625 203.0625 C-300.10168226 206.31107492 -303.69560168 209.42468216 -307.4375 212.4375 C-312.40706923 216.45138284 -317.10922906 220.68404653 -321.78515625 225.03125 C-324 227 -324 227 -326 228 C-326 228.66 -326 229.32 -326 230 C-326.52722656 230.21785156 -327.05445313 230.43570313 -327.59765625 230.66015625 C-330.90250052 232.50334582 -333.60862269 234.95246413 -336.4375 237.4375 C-337.68593799 238.51983114 -338.9346423 239.60185516 -340.18359375 240.68359375 C-340.8163623 241.2338623 -341.44913086 241.78413086 -342.10107422 242.35107422 C-345.05462529 244.9157803 -348.023139 247.4624123 -351 250 C-351.5148999 250.44400146 -352.0297998 250.88800293 -352.56030273 251.34545898 C-355.06951255 253.48275277 -357.59649243 255.42409121 -360.375 257.1875 C-361.24125 257.785625 -362.1075 258.38375 -363 259 C-363 259.66 -363 260.32 -363 261 C-364.11375 261.4021875 -364.11375 261.4021875 -365.25 261.8125 C-367.89061949 262.95276751 -369.85552844 264.09380306 -372 266 C-372 266.66 -372 267.32 -372 268 C-372.6703125 268.22816406 -373.340625 268.45632813 -374.03125 268.69140625 C-377.8337527 270.36750941 -381.08178677 272.59213191 -384.5 274.9375 C-388.61031804 277.73333019 -392.70196627 280.49556881 -397 283 C-396.34 283.33 -395.68 283.66 -395 284 C-392.1033897 282.66604553 -392.1033897 282.66604553 -388.8125 280.6875 C-388.19028564 280.32575684 -387.56807129 279.96401367 -386.92700195 279.59130859 C-381.75915866 276.54455157 -376.79056585 273.23382821 -371.83056641 269.86303711 C-365.04266454 265.2837858 -357.98108745 261.19785032 -350.89599609 257.10009766 C-348.25193522 255.56595675 -345.62389011 254.00584516 -343 252.4375 C-342.236875 251.98246094 -341.47375 251.52742187 -340.6875 251.05859375 C-339.03509864 250.10951161 -339.03509864 250.10951161 -338 249 C-336.44671453 248.13174359 -334.88187959 247.28412871 -333.3125 246.4453125 C-326.45715886 242.73237128 -319.72260682 238.82115314 -313 234.875 C-312.36415985 234.50216888 -311.7283197 234.12933777 -311.07321167 233.74520874 C-301.03229611 227.85131024 -291.1157407 221.79493095 -281.32519531 215.4921875 C-278.84571374 213.90098723 -276.35749759 212.32419527 -273.8671875 210.75 C-263.15900883 203.97512055 -252.52682717 197.09070043 -241.93261719 190.1395874 C-235.04466371 185.6219975 -228.13595419 181.1522134 -221.13012695 176.81982422 C-213.70638635 172.22173218 -206.37278702 167.48264274 -199.02539062 162.76391602 C-193.53050966 159.24044558 -188.01977727 155.75819834 -182.4375 152.375 C-181.47328125 151.77171875 -180.5090625 151.1684375 -179.515625 150.546875 C-177 149 -177 149 -174.734375 147.828125 C-164.01801455 141.52919557 -160.62677064 124.40993474 -157.09082031 113.29370117 C-155.40052697 108.0124136 -153.35704069 103.03820441 -150.8828125 98.06640625 C-149.80356499 95.91471723 -149.80356499 95.91471723 -150 93 C-153.66939993 93 -156.69255282 95.89727273 -159.6875 97.875 Z M-592 200 C-591 202 -591 202 -591 202 Z M-98.734375 208.953125 C-99.85448975 209.15824707 -100.97460449 209.36336914 -102.12866211 209.57470703 C-103.32370361 209.79755371 -104.51874512 210.02040039 -105.75 210.25 C-113.23143537 211.62698732 -120.70795563 212.98214292 -128.23046875 214.1171875 C-129.3606543 214.28831055 -130.49083984 214.45943359 -131.65527344 214.63574219 C-133.79913022 214.95531144 -135.94429702 215.26624467 -138.09082031 215.56738281 C-146.48973274 216.82708002 -150.63134289 219.37063976 -156.4375 225.5625 C-167.01213241 236.42903976 -179.65364459 243.9827291 -193 251 C-193.73299316 251.39421143 -194.46598633 251.78842285 -195.22119141 252.19458008 C-202.20540901 255.84040714 -209.44394701 258.47482977 -216.875 261.0625 C-218.06480469 261.48337891 -219.25460937 261.90425781 -220.48046875 262.33789062 C-227.95999179 264.97411596 -235.46803091 267.51785419 -243 270 C-239.19079756 272.07973696 -236.09892913 272.38339283 -231.75 272.625 C-230.48671875 272.69976562 -229.2234375 272.77453125 -227.921875 272.8515625 C-226.95765625 272.90054688 -225.9934375 272.94953125 -225 273 C-225 273.33 -225 273.66 -225 274 C-224.43410156 274.13277344 -223.86820313 274.26554687 -223.28515625 274.40234375 C-222.18494141 274.66724609 -222.18494141 274.66724609 -221.0625 274.9375 C-220.33160156 275.11152344 -219.60070312 275.28554688 -218.84765625 275.46484375 C-217 276 -217 276 -216 277 C-222.57343586 277.10020481 -228.9632494 276.73330192 -235.5 276.0625 C-236.38558594 275.97548828 -237.27117187 275.88847656 -238.18359375 275.79882812 C-239.06144531 275.71181641 -239.93929687 275.62480469 -240.84375 275.53515625 C-241.7188623 275.45233398 -242.59397461 275.36951172 -243.49560547 275.28417969 C-246 275 -246 275 -248.10205078 274.58300781 C-255.93398976 273.15497253 -263.33553247 275.66493315 -270.875 277.625 C-272.45923825 278.02542139 -274.04380236 278.42455539 -275.62866211 278.82250977 C-279.12667154 279.70401455 -282.62191867 280.59562824 -286.11572266 281.49365234 C-291.44732721 282.86231224 -296.78506972 284.20567736 -302.12420654 285.5446167 C-306.78558915 286.71399203 -311.44561633 287.88869842 -316.10528564 289.06488037 C-318.40695493 289.64583417 -320.70883455 290.22595534 -323.01092529 290.80523682 C-326.25984979 291.62438173 -329.50708488 292.44990739 -332.75390625 293.27734375 C-333.73147385 293.52285477 -334.70904144 293.76836578 -335.7162323 294.02131653 C-337.07014824 294.36835884 -337.07014824 294.36835884 -338.45141602 294.72241211 C-339.23694351 294.92176865 -340.02247101 295.12112518 -340.83180237 295.32652283 C-343.03860467 296.01199123 -344.93789619 296.96811957 -347 298 C-349.23859193 298.43798538 -351.49099487 298.80873928 -353.75 299.125 C-354.92046875 299.29257812 -356.0909375 299.46015625 -357.296875 299.6328125 C-358.18890625 299.75398438 -359.0809375 299.87515625 -360 300 C-360 300.33 -360 300.66 -360 301 C-326.7756198 301.56430225 -293.42541483 300.20945175 -260.3125 297.5 C-259.21010986 297.41049576 -259.21010986 297.41049576 -258.08544922 297.31918335 C-246.6970432 296.37806351 -235.19578334 295.36062576 -224 293 C-223.19973389 292.83725586 -222.39946777 292.67451172 -221.57495117 292.50683594 C-209.14839661 289.94268332 -196.99686017 287.14551189 -185 283 C-183.75863281 282.59523438 -182.51726562 282.19046875 -181.23828125 281.7734375 C-172.95039343 278.96548466 -165.31273441 275.23460464 -157.625 271.0625 C-156.72185059 270.57257568 -155.81870117 270.08265137 -154.88818359 269.57788086 C-148.63132285 266.09821229 -142.80487171 262.18296044 -137 258 C-136.03449219 257.33613281 -135.06898438 256.67226563 -134.07421875 255.98828125 C-124.51728778 249.27809568 -116.22440552 241.25106485 -108 233 C-106.84951172 231.90171875 -106.84951172 231.90171875 -105.67578125 230.78125 C-100.85070729 226.12365795 -96.46911983 221.30061383 -92.375 216 C-91.71818237 215.15405273 -91.71818237 215.15405273 -91.0480957 214.29101562 C-88.71390555 211.46006654 -88.71390555 211.46006654 -88 208 C-91.71257397 207.89673187 -95.08610306 208.27346325 -98.734375 208.953125 Z M-191.41772461 221.35131836 C-193.07976173 221.46660133 -193.07976173 221.46660133 -194.77537537 221.58421326 C-195.97227493 221.66857132 -197.1691745 221.75292938 -198.40234375 221.83984375 C-200.24621422 221.96946251 -200.24621422 221.96946251 -202.12733459 222.10169983 C-204.72905781 222.28519853 -207.33073621 222.46933347 -209.93237305 222.65405273 C-212.60052168 222.84337265 -215.26881097 223.03047937 -217.93725586 223.21557617 C-221.7800393 223.48268345 -225.62246687 223.75445763 -229.46484375 224.02734375 C-230.65971909 224.10967758 -231.85459442 224.19201141 -233.0856781 224.27684021 C-234.19685501 224.35684769 -235.30803192 224.43685516 -236.45288086 224.51928711 C-237.42978378 224.58812607 -238.40668671 224.65696503 -239.41319275 224.72789001 C-243.55520962 225.01569724 -243.55520962 225.01569724 -247 227 C-247 226.67 -247 226.34 -247 226 C-249.35488588 225.91816999 -251.70686161 225.85912432 -254.0625 225.8125 C-256.02896484 225.76029297 -256.02896484 225.76029297 -258.03515625 225.70703125 C-264.36261194 226.17457724 -269.10745121 228.89929561 -274.375 232.25 C-275.51740415 232.9648618 -276.66071744 233.67827175 -277.8046875 234.390625 C-278.78260254 235.00067383 -278.78260254 235.00067383 -279.78027344 235.62304688 C-293.75717604 244.29327682 -307.91160139 252.61994831 -322.3125 260.5625 C-322.91175293 260.8937085 -323.51100586 261.22491699 -324.12841797 261.56616211 C-331.9928351 265.90533749 -339.93506198 270.04605874 -348 274 C-344.17681698 275.26595464 -342.15023207 274.4671299 -338.48828125 272.7890625 C-336.17964462 272.05696737 -334.27173091 271.78180539 -331.87426758 271.55786133 C-327.34603425 271.07845375 -322.96733874 270.26343413 -318.5234375 269.28515625 C-317.73122803 269.11387711 -316.93901855 268.94259796 -316.12280273 268.76612854 C-313.53880505 268.20442875 -310.9567598 267.63439262 -308.375 267.0625 C-307.48725891 266.86702576 -306.59951782 266.67155151 -305.68487549 266.47015381 C-291.85663591 263.41707762 -278.09624091 260.12687579 -264.375 256.625 C-263.54393738 256.41449005 -262.71287476 256.2039801 -261.85662842 255.98709106 C-259.49370502 255.38637922 -257.13321029 254.77702095 -254.7734375 254.1640625 C-254.08660889 253.98935928 -253.39978027 253.81465607 -252.69213867 253.63465881 C-249.43898593 252.77685215 -246.35146357 251.77726909 -243.27783203 250.4230957 C-240.66189917 249.28736856 -238.5521077 248.55281673 -235.78125 248.06640625 C-230.15089704 246.90532458 -224.87156579 244.96041709 -219.5 242.9375 C-218.44917236 242.54191895 -217.39834473 242.14633789 -216.31567383 241.73876953 C-203.0261474 236.61424222 -190.81266699 229.93464241 -179 222 C-183.25120267 220.82725444 -187.04732972 221.04666295 -191.41772461 221.35131836 Z ",
    fill: "#0B161A",
    transform: "translate(876,124)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.13270715 2.28551795 -4.27585655 3.8742662 -6.9375 5.5 C-29.5768718 20.39626418 -43.0138437 44.21012217 -48.75 70.25 C-50.4852843 79.74785784 -51.22609486 89.3838465 -52 99 C-30.94626722 90.02713867 -9.01239035 79.93381526 5 61 C5.94746094 59.74316406 5.94746094 59.74316406 6.9140625 58.4609375 C13.53828345 48.76757943 16.65661468 37.97712997 20.10693359 26.85644531 C21.34856858 22.88511417 22.66980995 18.94235016 24 15 C24.391875 13.824375 24.78375 12.64875 25.1875 11.4375 C25.455625 10.633125 25.72375 9.82875 26 9 C26.66 9 27.32 9 28 9 C36.30037465 28.92723531 37.65990232 49.01287523 29.75 69.375 C19.12143117 92.78315753 -2.3058377 106.64533437 -23.46142578 119.46142578 C-39.31908069 129.07240301 -54.86549888 138.66877886 -69.109375 150.6015625 C-71 152 -71 152 -73 152 C-76.21844102 145.65898642 -78.6876522 139.24666775 -80.6875 132.4375 C-80.88947998 131.75437744 -81.09145996 131.07125488 -81.29956055 130.36743164 C-81.90263306 128.25279111 -82.46056147 126.13173694 -83 124 C-83.18981445 123.27337158 -83.37962891 122.54674316 -83.57519531 121.7980957 C-85.2246442 114.71269474 -85.37230516 107.64095152 -85.37060547 100.39770508 C-85.37495755 98.33264245 -85.41133464 96.26976205 -85.44921875 94.20507812 C-85.55698874 81.65795961 -83.21459111 69.90646605 -77.1875 58.75 C-76.83913086 58.08436035 -76.49076172 57.4187207 -76.13183594 56.73291016 C-75.11037745 54.80849723 -74.06302504 52.9017087 -73 51 C-72.45472656 50.02289063 -71.90945313 49.04578125 -71.34765625 48.0390625 C-57.69230443 25.26901375 -36.28063654 7.85525973 -10.625 0.6875 C-6.90869165 -0.0173171 -3.76115671 -0.15671486 0 0 Z ",
    fill: "#E8B843",
    transform: "translate(332,379)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.84512709 6.63769899 12.76829934 13.71278058 18 21.6875 C18.51328857 22.46697998 19.02657715 23.24645996 19.55541992 24.04956055 C31.05493762 41.70727011 31.05493762 41.70727011 30.94140625 46.4453125 C29.6803979 49.86730197 27.76931643 52.64911468 25.625 55.5625 C25.17801758 56.17528809 24.73103516 56.78807617 24.27050781 57.41943359 C0.97302538 88.7826763 -35.76633432 109.25174648 -74.25 115.3125 C-84.11876215 116.46403495 -94.08127409 116.17670746 -104 116 C-109.4680452 105.4626896 -111.95545896 96.01673382 -111 84 C-109.36888892 82.36888892 -107.28127693 82.50195369 -105.08764648 82.15161133 C-67.68078385 76.07534748 -35.66614328 51.29764048 -13.4296875 21.45703125 C-9.89520951 16.54962142 -6.84252072 11.34569245 -3.8125 6.1171875 C-2.60478155 4.04012 -1.33275807 1.99913711 0 0 Z ",
    fill: "#E8B742",
    transform: "translate(680,556)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.3230788 20.07050424 -0.47892624 39.73103014 -13 55 C-13.55042969 55.68707031 -14.10085938 56.37414062 -14.66796875 57.08203125 C-28.43274624 72.48764315 -54.08519758 80.34450569 -74 82 C-106.17102196 83.38005463 -106.17102196 83.38005463 -115 79 C-118.51997048 74.76089576 -120.14997507 70.31600055 -121.6875 65.125 C-121.89955078 64.45597656 -122.11160156 63.78695312 -122.33007812 63.09765625 C-123.76197699 58.40897794 -124.50362278 53.87649712 -125 49 C-124.26700684 48.96036133 -123.53401367 48.92072266 -122.77880859 48.87988281 C-80.47440927 46.49114587 -42.11948193 37.95484558 -10 9 C-8.99119972 8.1012096 -7.98209074 7.20276556 -6.97265625 6.3046875 C-4.63726442 4.214954 -2.31292689 2.11452684 0 0 Z ",
    fill: "#E8B843",
    transform: "translate(720,667)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C13.52825309 0.05959583 27.34539056 5.38205595 39 12 C38.43235629 16.95485612 36.19738973 20.61243271 33.6875 24.8125 C33.2445459 25.55661133 32.8015918 26.30072266 32.34521484 27.06738281 C22.65413159 43.02480477 10.63295721 58.28832282 -4 70 C-4.90621094 70.74378906 -5.81242188 71.48757813 -6.74609375 72.25390625 C-13.04110605 77.32150685 -19.60838559 81.77984625 -26.5 86 C-27.26554199 86.46889648 -28.03108398 86.93779297 -28.81982422 87.42089844 C-32.4593513 89.60831127 -35.97190138 91.59336239 -40 93 C-41.29747899 89.01339117 -41.2209736 84.95964742 -41.25 80.8125 C-41.2809375 79.73645508 -41.2809375 79.73645508 -41.3125 78.63867188 C-41.3796094 69.26852231 -38.25705232 62.60286414 -32.4375 55.4375 C-26.34905309 47.62388533 -21.03403615 39.52504885 -16 31 C-15.60683594 30.33468262 -15.21367188 29.66936523 -14.80859375 28.98388672 C-9.29237667 19.57400321 -4.4488873 9.95635228 0 0 Z ",
    fill: "#E8B843",
    transform: "translate(596,507)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.59414751 0.59947315 9.01633021 1.44821162 13.515625 2.54296875 C20.99283673 4.1671172 28.12100646 4.41943463 35.75 4.3125 C37.6993042 4.29993164 37.6993042 4.29993164 39.68798828 4.28710938 C49.55762938 4.16445943 59.24415458 3.48056191 69 2 C60.51785446 23.33388121 26.32622087 38.42965609 7.1875 47.125 C6.38223877 47.49125488 5.57697754 47.85750977 4.74731445 48.23486328 C-0.10719022 50.36675455 -4.82227707 51.85464282 -10 53 C-9.49638201 44.69552737 -8.01835394 36.84067227 -6.125 28.75 C-5.5821393 26.37397041 -5.04046483 23.99766947 -4.5 21.62109375 C-4.24089844 20.48655762 -3.98179687 19.35202148 -3.71484375 18.18310547 C-2.35889356 12.14523712 -1.16065025 6.07814212 0 0 Z ",
    fill: "#E8B742",
    transform: "translate(608,783)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.79750453 1.0639324 15.48738102 2.44787651 23.1875 4.0625 C24.44397339 4.32401855 24.44397339 4.32401855 25.72583008 4.59082031 C31.74616706 5.87308353 31.74616706 5.87308353 34 7 C33.34 8.98 32.68 10.96 32 13 C31.67 12.01 31.34 11.02 31 10 C31.33 9.34 31.66 8.68 32 8 C26.555 7.505 26.555 7.505 21 7 C21 6.34 21 5.68 21 5 C19.35 5.33 17.7 5.66 16 6 C16 5.34 16 4.68 16 4 C15.11248047 3.90912109 15.11248047 3.90912109 14.20703125 3.81640625 C13.41683594 3.73261719 12.62664062 3.64882813 11.8125 3.5625 C11.03519531 3.48128906 10.25789063 3.40007813 9.45703125 3.31640625 C6.93998004 2.99227088 4.4822857 2.52467495 2 2 C2.24234375 3.24007812 2.4846875 4.48015625 2.734375 5.7578125 C7.37730143 30.03722867 10.16349802 54.38814239 12.25 79 C12.33894531 80.04735321 12.42789062 81.09470642 12.51953125 82.17379761 C12.77241805 85.17803735 13.02038108 88.18262744 13.265625 91.1875 C13.34041077 92.08940567 13.41519653 92.99131134 13.49224854 93.92054749 C14.24626733 103.3805738 14.24626733 103.3805738 14 107 C13.01 107.99 13.01 107.99 12 109 C11.95877014 108.4343483 11.91754028 107.86869659 11.87506104 107.28590393 C8.09230143 55.31157828 8.09230143 55.31157828 0.30371094 3.81469727 C0 2 0 2 0 0 Z ",
    fill: "#848787",
    transform: "translate(498,543)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C0.30271961 4.34061543 0.63837971 5.67405895 1 7 C1.33333333 8.33333333 1.66666667 9.66666667 2 11 C3.32 11.33 4.64 11.66 6 12 C0.17062143 16.41710644 -5.6707708 20.81445344 -11.625 25.0625 C-12.42164063 25.63097656 -13.21828125 26.19945312 -14.0390625 26.78515625 C-16 28 -16 28 -18 28 C-17.36967149 24.51078814 -15.9881271 22.25098318 -13.9453125 19.375 C-13.33042969 18.50359375 -12.71554687 17.6321875 -12.08203125 16.734375 C-11.43621094 15.83203125 -10.79039062 14.9296875 -10.125 14 C-9.48691406 13.09765625 -8.84882813 12.1953125 -8.19140625 11.265625 C-5.50561818 7.47524351 -2.80025144 3.70686855 0 0 Z M-2 7 C-1 9 -1 9 -1 9 Z ",
    fill: "#161E20",
    transform: "translate(279,681)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 0.33 15 0.66 15 1 C18.3 1.99 21.6 2.98 25 4 C23 6 23 6 19.03125 6.18359375 C13.82946235 6.06603335 8.6735815 5.59341339 3.5 5.0625 C2.17162109 4.93198242 2.17162109 4.93198242 0.81640625 4.79882812 C-6.57795673 4.06590668 -6.57795673 4.06590668 -9.0297699 3.68302917 C-14.59773408 2.8856568 -18.99860234 3.29173372 -24.41015625 4.73046875 C-25.18072861 4.92216141 -25.95130096 5.11385406 -26.745224 5.31135559 C-29.18816364 5.92253392 -31.62514458 6.5544616 -34.0625 7.1875 C-35.66826603 7.59319965 -37.27438467 7.9975063 -38.88085938 8.40039062 C-45.13302705 9.9744403 -51.38015268 11.56440405 -57.60888672 13.22900391 C-58.33828964 13.42029373 -59.06769257 13.61158356 -59.81919861 13.80867004 C-61.80623628 14.32987506 -63.79078599 14.86053901 -65.77514648 15.3918457 C-68.73397996 15.949833 -70.23991546 16.06675992 -73 15 C-68.14754274 13.58824708 -63.27982888 12.24043834 -58.40136719 10.92138672 C-55.88994952 10.2410759 -53.38057509 9.55464512 -50.87207031 8.86376953 C-47.00414575 7.80201182 -43.12878763 6.77099629 -39.24890137 5.75387573 C-37.6867833 5.3400514 -36.12685846 4.917842 -34.56945801 4.48660278 C-23.52532691 1.43832408 -14.41146846 0.66280707 -3 2 C-1.45906481 2.11566555 0.08251743 2.22363084 1.625 2.31640625 C2.73875 2.39761719 3.8525 2.47882813 5 2.5625 C6.155 2.64628906 7.31 2.73007812 8.5 2.81640625 C9.325 2.87699219 10.15 2.93757813 11 3 C5.555 2.01 5.555 2.01 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#7D8282",
    transform: "translate(637,396)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.66 1.98 1.32 3 2 C2.34 2 1.68 2 1 2 C1.33 2.66 1.66 3.32 2 4 C2.36117679 7.34267919 2.46720359 10.70468518 2.625 14.0625 C2.70234375 15.46725586 2.70234375 15.46725586 2.78125 16.90039062 C2.82507813 17.79048828 2.86890625 18.68058594 2.9140625 19.59765625 C2.9548291 20.41758057 2.9955957 21.23750488 3.03759766 22.08227539 C3 24 3 24 2 25 C1.75960934 26.76368639 1.57864569 28.53551724 1.421875 30.30859375 C-1.42004833 60.49431129 -6.82447845 90.67494538 -18 119 C-19.13537573 115.59387282 -18.86544926 114.85167076 -17.77734375 111.5546875 C-17.48899658 110.65580811 -17.20064941 109.75692871 -16.90356445 108.83081055 C-16.58476318 107.85539307 -16.26596191 106.87997559 -15.9375 105.875 C-9.34532618 84.88635313 -4.88491958 63.80480744 -2 42 C-1.89905029 41.29174072 -1.79810059 40.58348145 -1.6940918 39.85375977 C-0.66585799 31.93075778 -0.64637677 23.91488767 -0.4375 15.9375 C-0.39422008 14.38866234 -0.35060308 12.83983406 -0.30664062 11.29101562 C-0.20053934 7.52744068 -0.09900464 3.76376805 0 0 Z ",
    fill: "#868989",
    transform: "translate(893,131)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-3.51480675 2.3432045 -6.95642669 3.15367901 -11 4.125 C-12.08667969 4.39763672 -12.08667969 4.39763672 -13.1953125 4.67578125 C-16.19964996 5.41300797 -18.89517284 6 -22 6 C-22.33 6.99 -22.66 7.98 -23 9 C-23 8.34 -23 7.68 -23 7 C-25.97 7.66 -28.94 8.32 -32 9 C-17.98175981 9.10904422 -4.0178885 8.94956896 9.98876953 8.35791016 C20.99443218 7.91370667 31.98731072 7.89615192 43 8 C43 8.33 43 8.66 43 9 C35.67073835 9.72261496 28.35845149 10.25599088 21 10.55859375 C19.97455078 10.60084579 18.94910156 10.64309784 17.89257812 10.68663025 C5.59621916 11.14817273 -6.69705002 11.10932295 -19 11.0625 C-21.34765527 11.0574649 -23.69531162 11.05290562 -26.04296875 11.04882812 C-31.69533656 11.03800481 -37.34766295 11.02143246 -43 11 C-42.67 10.34 -42.34 9.68 -42 9 C-39.35131836 8.16210938 -39.35131836 8.16210938 -35.83984375 7.34375 C-34.57076172 7.04339844 -33.30167969 6.74304688 -31.99414062 6.43359375 C-30.64198406 6.12214838 -29.28977002 5.81095239 -27.9375 5.5 C-26.61244886 5.18957517 -25.28757655 4.87838591 -23.96289062 4.56640625 C-21.42642718 3.97034374 -18.88917968 3.37760561 -16.35107422 2.78857422 C-13.64292548 2.15129311 -10.9473176 1.48507106 -8.25390625 0.7890625 C-5.34655079 0.08403753 -2.97188517 -0.18574282 0 0 Z ",
    fill: "#838787",
    transform: "translate(552,415)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.93457031 0.09345703 1.86914062 0.18691406 2.83203125 0.28320312 C3.66911621 0.372229 4.50620117 0.46125488 5.36865234 0.55297852 C7.6891607 0.62321537 9.47460562 0.30163532 11.68359375 -0.37695312 C11.35359375 0.61304688 11.02359375 1.60304688 10.68359375 2.62304688 C12.00359375 2.95304687 13.32359375 3.28304688 14.68359375 3.62304688 C13.16257052 3.47920766 11.64178478 3.33285674 10.12109375 3.18554688 C9.27417969 3.10433594 8.42726563 3.023125 7.5546875 2.93945312 C5.51211516 2.71435332 3.47524027 2.43468 1.44482422 2.11816406 C-4.88992674 1.2842763 -11.24935382 1.33611476 -17.62890625 1.31054688 C-18.69564575 1.30462524 -18.69564575 1.30462524 -19.78393555 1.29858398 C-31.04283081 1.2693599 -41.5225586 2.26496094 -52.31640625 5.62304688 C-51.5392627 5.79433105 -50.76211914 5.96561523 -49.96142578 6.14208984 C-46.45301757 6.91981063 -42.94723349 7.70877687 -39.44140625 8.49804688 C-38.21808594 8.76746094 -36.99476562 9.036875 -35.734375 9.31445312 C-34.56777344 9.57871094 -33.40117188 9.84296875 -32.19921875 10.11523438 C-31.12043457 10.35612793 -30.04165039 10.59702148 -28.93017578 10.84521484 C-26.31640625 11.62304688 -26.31640625 11.62304688 -24.31640625 13.62304688 C-30.87301444 12.80464671 -37.29295583 11.4294248 -43.75390625 10.06054688 C-44.86701172 9.82658203 -45.98011719 9.59261719 -47.12695312 9.3515625 C-49.85719885 8.77739065 -52.58699365 8.20116379 -55.31640625 7.62304688 C-55.31640625 6.63304687 -55.31640625 5.64304687 -55.31640625 4.62304688 C-37.89654075 -2.74689622 -18.42317787 -1.96954292 0 0 Z ",
    fill: "#888B8B",
    transform: "translate(160.31640625,283.376953125)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.375 1.5 -1.375 1.5 -3 3 C-3.66 3 -4.32 3 -5 3 C-5 3.66 -5 4.32 -5 5 C-6.2065625 5.556875 -6.2065625 5.556875 -7.4375 6.125 C-11.88421152 8.3323604 -15.91516053 11.1950769 -20 14 C-20.66 13.67 -21.32 13.34 -22 13 C-21.01 12.01 -20.02 11.02 -19 10 C-19.33 9.34 -19.66 8.68 -20 8 C-26.14154225 8.58490879 -32.00679849 9.54066252 -38 11 C-34.34179219 7.34179219 -28.72024814 6.50789854 -23.84350586 5.00390625 C-21.83380202 4.38159623 -19.83006635 3.74229535 -17.82617188 3.1015625 C-16.53678647 2.69946709 -15.24708198 2.29839319 -13.95703125 1.8984375 C-12.79147705 1.53411621 -11.62592285 1.16979492 -10.42504883 0.79443359 C-6.83715973 -0.03777049 -3.67000073 -0.14206454 0 0 Z ",
    fill: "#5B6061",
    transform: "translate(808,232)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-3.07163914 3.07163914 -6.84814996 2.67729288 -11 3 C-11.97119781 3.07815948 -12.94239563 3.15631897 -13.94302368 3.23684692 C-17.29058789 3.4955272 -20.63907925 3.73614789 -23.98828125 3.97265625 C-25.20903854 4.06002548 -26.42979584 4.14739471 -27.68754578 4.2374115 C-30.25330574 4.42061042 -32.81912843 4.60293269 -35.38500977 4.78442383 C-39.31739659 5.06284669 -43.24952677 5.3447041 -47.18164062 5.62695312 C-49.67967297 5.80489156 -52.17771937 5.98263284 -54.67578125 6.16015625 C-56.43986076 6.28669334 -56.43986076 6.28669334 -58.23957825 6.41578674 C-59.33138901 6.49264206 -60.42319977 6.56949738 -61.5480957 6.64868164 C-62.98630424 6.75074669 -62.98630424 6.75074669 -64.4535675 6.85487366 C-66.63271166 6.97906749 -68.81731969 7 -71 7 C-71 7.66 -71 8.32 -71 9 C-73.31 9 -75.62 9 -78 9 C-78 8.67 -78 8.34 -78 8 C-80.31 7.67 -82.62 7.34 -85 7 C-85.33 7.66 -85.66 8.32 -86 9 C-87.65 8.67 -89.3 8.34 -91 8 C-88.19131499 5.19131499 -86.18554726 5.5843744 -82.24633789 5.32983398 C-81.55170441 5.28238037 -80.85707092 5.23492676 -80.14138794 5.18603516 C-77.83563026 5.03066878 -75.52925235 4.88842339 -73.22265625 4.74609375 C-71.61513255 4.64009317 -70.00766529 4.53323353 -68.4002533 4.42555237 C-64.15527259 4.14332609 -59.90966437 3.87200251 -55.66381836 3.60314941 C-50.54359134 3.27709836 -45.42414323 2.93909472 -40.30462551 2.6021204 C-36.31161615 2.33942562 -32.31851617 2.07868572 -28.32496643 1.82432556 C-21.30527899 1.3740702 -14.29683859 0.89409068 -7.2978363 0.17933655 C-4.85649171 -0.01120022 -2.44777202 -0.02985605 0 0 Z ",
    fill: "#7A8080",
    transform: "translate(701,343)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C16.17776962 24.26665443 12.64315918 65.72143984 8 93 C7.67 93 7.34 93 7 93 C7.06058594 92.28457031 7.12117187 91.56914063 7.18359375 90.83203125 C7.36149933 88.71632339 7.53708406 86.60041969 7.7109375 84.484375 C7.89678066 82.24421154 8.08896443 80.00456019 8.2890625 77.765625 C8.93837873 70.15934915 9.11242341 62.63230008 9 55 C8.34 55 7.68 55 7 55 C7 54.34 7 53.68 7 53 C7.66 53 8.32 53 9 53 C7.56478003 36.89558735 5.13752906 21.65855198 0.50317383 6.15283203 C0 4 0 4 0 0 Z ",
    fill: "#8C8E8E",
    transform: "translate(565,729)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C15.92259574 3.53835461 28.97499664 19.76387955 40 31 C39.67 31.66 39.34 32.32 39 33 C38.51644043 32.50072998 38.03288086 32.00145996 37.53466797 31.48706055 C35.32282253 29.21255585 33.09910545 26.95001517 30.875 24.6875 C29.73417969 23.50897461 29.73417969 23.50897461 28.5703125 22.30664062 C24.59258095 18.27747289 21.24855816 15.28973926 16 13 C14.29665046 11.73547069 12.62843784 10.42214121 11 9.0625 C8.19392697 6.75660313 5.42859976 4.530697 2.375 2.5625 C1.59125 2.046875 0.8075 1.53125 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#5C605F",
    transform: "translate(218,308)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.71789631 -1.32350649 5.71407272 -3 9 C-3.68636625 11.23525035 -3.68636625 11.23525035 -4 13 C-2.68 13.33 -1.36 13.66 0 14 C-2.1217363 15.33878572 -4.24705188 16.67115476 -6.375 18 C-6.97828125 18.3815625 -7.5815625 18.763125 -8.203125 19.15625 C-12.7734375 22 -12.7734375 22 -15 22 C-14.46518512 17.7109944 -11.7937297 14.82494777 -9.1875 11.5625 C-8.74857422 11.00240234 -8.30964844 10.44230469 -7.85742188 9.86523438 C-6.57908249 8.23739359 -5.29169078 6.61725935 -4 5 C-2.84951172 3.55947266 -2.84951172 3.55947266 -1.67578125 2.08984375 C-1.12277344 1.40019531 -0.56976563 0.71054687 0 0 Z ",
    fill: "#272B2B",
    transform: "translate(346,742)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C0.70125 2.855625 1.4025 2.71125 2.125 2.5625 C5.07556141 1.98521625 8.03270151 1.48304859 11 1 C7.6332699 4.62050373 3.88740631 7.40408707 -0.125 10.25 C-0.75792969 10.70890625 -1.39085937 11.1678125 -2.04296875 11.640625 C-6.75209263 15 -6.75209263 15 -9 15 C-8.39889717 10.99264783 -6.33397972 8.44530629 -3.9375 5.25 C-2.83728516 3.77273438 -2.83728516 3.77273438 -1.71484375 2.265625 C-1.14894531 1.51796875 -0.58304687 0.7703125 0 0 Z ",
    fill: "#454848",
    transform: "translate(270,694)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.495 0.99 0.495 0.99 1 2 C0.443125 1.80664062 -0.11375 1.61328125 -0.6875 1.4140625 C-13.08115144 -2.81485235 -24.12744972 -4.9607847 -37 -1 C-40.34088433 -0.83171842 -43.6580455 -0.87896342 -47 -1 C-33.70148813 -9.86567458 -13.56496175 -6.29241723 0 0 Z ",
    fill: "#858A8A",
    transform: "translate(378,338)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0.33 5.28 0.66 8 1 C8 1.66 8 2.32 8 3 C8.721875 3.28875 9.44375 3.5775 10.1875 3.875 C11.115625 4.24625 12.04375 4.6175 13 5 C13.76570312 5.28359375 14.53140625 5.5671875 15.3203125 5.859375 C18.30270486 7.12884813 20.9390787 8.65770538 23.6875 10.375 C24.64011719 10.96023438 25.59273437 11.54546875 26.57421875 12.1484375 C28.99618728 13.99708981 29.9413563 15.18933193 31 18 C30.01 18 29.02 18 28 18 C28 17.34 28 16.68 28 16 C27.360625 15.773125 26.72125 15.54625 26.0625 15.3125 C22.55552674 13.80951146 19.3054038 11.99986736 15.98828125 10.12109375 C13.64236788 8.79834888 11.57250464 7.85750155 9 7 C9 6.34 9 5.68 9 5 C8.2575 4.71125 7.515 4.4225 6.75 4.125 C4.43260203 3.17697356 2.22082885 2.15154089 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#4A4E4E",
    transform: "translate(180,313)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.37478516 0.01740234 1.37478516 0.01740234 2.77734375 0.03515625 C3.69644531 0.04417969 4.61554687 0.05320312 5.5625 0.0625 C6.27277344 0.07410156 6.98304688 0.08570313 7.71484375 0.09765625 C7.86695313 0.731875 8.0190625 1.36609375 8.17578125 2.01953125 C9.48323407 4.22153305 9.48323407 4.22153305 11.47363281 4.61523438 C13.76174177 4.94492112 16.0351037 5.16806612 18.33984375 5.34765625 C19.14164063 5.425 19.9434375 5.50234375 20.76953125 5.58203125 C22.74978086 5.77062645 24.7321866 5.93632655 26.71484375 6.09765625 C26.71484375 6.42765625 26.71484375 6.75765625 26.71484375 7.09765625 C20.35159526 7.17455351 14.11237779 6.94389475 7.77734375 6.34765625 C6.92849609 6.28578125 6.07964844 6.22390625 5.20507812 6.16015625 C4.39490234 6.0828125 3.58472656 6.00546875 2.75 5.92578125 C2.02176025 5.86293945 1.29352051 5.80009766 0.54321289 5.73535156 C-1.28515625 5.09765625 -1.28515625 5.09765625 -2.53735352 3.04589844 C-2.78412842 2.40297852 -3.03090332 1.76005859 -3.28515625 1.09765625 C-2.28515625 0.09765625 -2.28515625 0.09765625 0 0 Z ",
    fill: "#0D1010",
    transform: "translate(627.28515625,392.90234375)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C3.58551741 10.2508879 3.12399937 19.95986462 3.0625 29.3125 C3.05746607 30.65038892 3.05290657 31.9882797 3.04882812 33.32617188 C3.03718676 36.55083085 3.02083703 39.7753896 3 43 C2.67 43 2.34 43 2 43 C1.98018066 42.31075439 1.96036133 41.62150879 1.93994141 40.91137695 C1.5019146 22.85468314 1.5019146 22.85468314 -1 5 C-3.31 6.98 -5.62 8.96 -8 11 C-8.66 10.67 -9.32 10.34 -10 10 C-6.7 6.7 -3.4 3.4 0 0 Z ",
    fill: "#898E8E",
    transform: "translate(474,602)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.26 0 14.52 0 22 0 C22 0.33 22 0.66 22 1 C19.36 1 16.72 1 14 1 C14 1.99 14 2.98 14 4 C12.68 4.33 11.36 4.66 10 5 C11.98 5.99 13.96 6.98 16 8 C13 9 13 9 10.51953125 8.00390625 C9.62621094 7.52824219 8.73289063 7.05257812 7.8125 6.5625 C6.91144531 6.08941406 6.01039063 5.61632812 5.08203125 5.12890625 C4.39496094 4.75636719 3.70789063 4.38382813 3 4 C3 3.34 3 2.68 3 2 C2.01 1.67 1.02 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#3E4344",
    transform: "translate(194,240)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-17.6432744 3.37061011 -35.24937426 5.58442019 -53 7 C-49.89545499 3.54329765 -47.66104816 3.36992446 -43 3 C-41.5259159 3.01553285 -40.05191867 3.04109105 -38.578125 3.07421875 C-32.25588987 3.09449532 -26.07575147 2.2968148 -19.8125 1.5 C-6.19233997 -0.21507404 -6.19233997 -0.21507404 0 0 Z ",
    fill: "#909494",
    transform: "translate(688,327)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.90585709 5.71757126 -1.18745244 11.2771692 -3.65625 16.51171875 C-8.41311202 25.80437067 -8.41311202 25.80437067 -12 27 C-11.237442 22.97369377 -9.43584228 19.4210181 -7.6875 15.75 C-7.37353271 15.08411865 -7.05956543 14.4182373 -6.73608398 13.73217773 C-4.55487262 9.12177505 -2.31803414 4.54334692 0 0 Z ",
    fill: "#37393A",
    transform: "translate(865,267)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-7.61232575 3.14795426 -15.31031349 5.82120924 -23.14453125 8.35546875 C-28.51608032 10.1141537 -33.71295156 12.06905456 -38.88867188 14.34570312 C-41 15 -41 15 -44 14 C-32.99155147 9.59249868 -21.9774663 5.19866058 -10.75 1.375 C-9.6355249 0.98610596 -9.6355249 0.98610596 -8.49853516 0.58935547 C-3.3604019 -1.12013397 -3.3604019 -1.12013397 0 0 Z ",
    fill: "#8A8E8E",
    transform: "translate(857,159)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.79208584 8.23342964 8.94258057 19.77981079 11 30 C9.68 30.99 8.36 31.98 7 33 C6.34 32.67 5.68 32.34 5 32 C5.99 31.34 6.98 30.68 8 30 C7.36418969 23.16503913 5.65944546 16.32764609 3 10 C2.01 9.67 1.02 9.34 0 9 C-0.84454356 5.62182575 -1.10844919 3.32534757 0 0 Z M1 5 C2 7 2 7 2 7 Z ",
    fill: "#767B7C",
    transform: "translate(283,319)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-14.48793216 12.92596217 -14.48793216 12.92596217 -20 16 C-20.66 15.67 -21.32 15.34 -22 15 C-16.45500126 9.76477772 -10.68175262 5.67041853 -4 2 C-3.28328125 1.59394531 -2.5665625 1.18789063 -1.828125 0.76953125 C-1.22484375 0.51558594 -0.6215625 0.26164063 0 0 Z ",
    fill: "#545756",
    transform: "translate(651,842)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.33870514 5.54479944 12.48943773 12.72565922 18 20 C17.67 20.66 17.34 21.32 17 22 C13.64459653 20.88153218 13.13074156 20.20759172 11.125 17.4375 C10.60550781 16.72078125 10.08601562 16.0040625 9.55078125 15.265625 C7.65210584 12.49174153 5.88425411 9.65614184 4.17578125 6.76171875 C3.03995843 4.927993 3.03995843 4.927993 1.35546875 3.39453125 C0 2 0 2 0 0 Z ",
    fill: "#535656",
    transform: "translate(697,522)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.39188126 14.32543718 1.40460073 27.87297073 -1 42 C-1.33 42 -1.66 42 -2 42 C-1.93941406 41.28457031 -1.87882813 40.56914063 -1.81640625 39.83203125 C-1.63850067 37.71632339 -1.46291594 35.60041969 -1.2890625 33.484375 C-1.10321934 31.24421154 -0.91103557 29.00456019 -0.7109375 26.765625 C-0.06162127 19.15934915 0.11242341 11.63230008 0 4 C-0.66 4 -1.32 4 -2 4 C-2 3.34 -2 2.68 -2 2 C-1.34 2 -0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#818484",
    transform: "translate(574,780)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.36595933 2.61500768 -4.86049226 4.38999603 -8 6 C-8.66 5.67 -9.32 5.34 -10 5 C-9.67 4.67 -9.34 4.34 -9 4 C-9.65226562 4.13277344 -10.30453125 4.26554687 -10.9765625 4.40234375 C-15.6408287 5.34482822 -20.29868454 6.25768703 -25 7 C-21.65570611 4.1038249 -18.41976365 3.00927228 -14.1875 1.8125 C-13.00542969 1.46832031 -11.82335937 1.12414062 -10.60546875 0.76953125 C-6.95835526 -0.00888842 -3.71693137 -0.13801666 0 0 Z ",
    fill: "#E7D95C",
    transform: "translate(332,379)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-19.10679612 9 -19.10679612 9 -24 9 C-23.45773019 5.20411134 -21.79872437 3.52788007 -19 1 C-18.67 1.99 -18.34 2.98 -18 4 C-13.12095967 3.49958561 -9.37899127 1.91003017 -5.05078125 -0.2578125 C-3 -1 -3 -1 0 0 Z ",
    fill: "#818585",
    transform: "translate(556,896)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.72869407 0.03287583 5.2966618 0.56397771 8 1 C6.16662007 3.43363243 5.17801907 3.96827143 2.12890625 4.51171875 C0.36353516 4.59873047 0.36353516 4.59873047 -1.4375 4.6875 C-2.07695557 4.72093506 -2.71641113 4.75437012 -3.37524414 4.78881836 C-12.24134172 5.19292012 -21.12778602 5.08106591 -30 5 C-30 4.67 -30 4.34 -30 4 C-29.16227051 3.9498877 -28.32454102 3.89977539 -27.46142578 3.84814453 C-24.35608723 3.65796896 -21.25142267 3.45950139 -18.14697266 3.25537109 C-16.80278257 3.16870151 -15.45837437 3.0853488 -14.11376953 3.00537109 C-12.18207666 2.8898972 -10.2511677 2.76153618 -8.3203125 2.6328125 C-7.15773926 2.55949707 -5.99516602 2.48618164 -4.79736328 2.41064453 C-1.86679967 2.26473862 -1.86679967 2.26473862 0 0 Z ",
    fill: "#E1A93A",
    transform: "translate(666,786)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.2065625 0.0309375 1.2065625 0.0309375 2.4375 0.0625 C-1.00511579 3.79047536 -5.22639673 5.87762032 -9.625 8.3125 C-10.45322266 8.78429687 -11.28144531 9.25609375 -12.13476562 9.7421875 C-12.92689453 10.18304687 -13.71902344 10.62390625 -14.53515625 11.078125 C-15.62195679 11.68575684 -15.62195679 11.68575684 -16.73071289 12.30566406 C-17.33520264 12.55541992 -17.93969238 12.80517578 -18.5625 13.0625 C-19.2225 12.7325 -19.8825 12.4025 -20.5625 12.0625 C-18.33894774 9.5054149 -16.81231807 8.82079088 -13.5625 8.0625 C-13.2325 7.4025 -12.9025 6.7425 -12.5625 6.0625 C-11.09367053 5.15578027 -9.58764118 4.30842135 -8.0625 3.5 C-1.57053944 0.03830584 -1.57053944 0.03830584 0 0 Z ",
    fill: "#585A59",
    transform: "translate(626.5625,857.9375)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-17.73076923 13 -17.73076923 13 -23 13 C-22.67 12.01 -22.34 11.02 -22 10 C-20 9.33333333 -18 8.66666667 -16 8 C-14.6256709 6.70896357 -13.29103643 5.3743291 -12 4 C-3.42857143 -1.71428571 -3.42857143 -1.71428571 0 0 Z ",
    fill: "#555959",
    transform: "translate(706,362)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.2065625 0.0309375 1.2065625 0.0309375 2.4375 0.0625 C-0.71570949 3.50307094 -4.23042588 5.95924158 -8.1875 8.375 C-8.77273438 8.74689453 -9.35796875 9.11878906 -9.9609375 9.50195312 C-11.45558798 10.42239729 -13.00613527 11.25075721 -14.5625 12.0625 C-15.2225 11.7325 -15.8825 11.4025 -16.5625 11.0625 C-14.44036881 5.75717203 -10.655453 4.32825818 -5.7421875 2.078125 C-1.35303653 0.03300089 -1.35303653 0.03300089 0 0 Z ",
    fill: "#424546",
    transform: "translate(700.5625,290.9375)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 3 1 3 -0.4765625 6.328125 C-1.18100659 7.64175922 -1.8978377 8.94880388 -2.625 10.25 C-2.99238281 10.92297119 -3.35976563 11.59594238 -3.73828125 12.28930664 C-6.21345722 16.76145025 -8.85098112 20.96531957 -12 25 C-12.33 24.34 -12.66 23.68 -13 23 C-11.45298221 18.82305198 -9.85158375 15.44566369 -7 12 C-3.98280034 8.32688737 -2.03918442 4.26469026 0 0 Z ",
    fill: "#636666",
    transform: "translate(417,678)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.39613065 0.14295891 2.79189308 0.28951558 4.1875 0.4375 C4.96480469 0.51871094 5.74210937 0.59992187 6.54296875 0.68359375 C9 1 9 1 11.28125 1.5 C14.94700895 2.17416257 18.59487627 2.35984133 22.3125 2.5625 C23.05306641 2.60568359 23.79363281 2.64886719 24.55664062 2.69335938 C26.37091464 2.79870432 28.1854355 2.89978316 30 3 C29.67 4.65 29.34 6.3 29 8 C28.67 7.01 28.34 6.02 28 5 C26.47632813 4.94392578 26.47632813 4.94392578 24.921875 4.88671875 C16.28193656 4.49830046 8.33278304 3.50930398 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#848889",
    transform: "translate(438,546)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.6875 -0.25 2.6875 -0.25 5 0 C-1.53583354 7.05620245 -12.09873219 11.79154863 -21 15 C-21.99 14.67 -22.98 14.34 -24 14 C-23.37955811 13.71801758 -22.75911621 13.43603516 -22.11987305 13.14550781 C-19.30385707 11.85809585 -16.49573903 10.55428323 -13.6875 9.25 C-12.71103516 8.8065625 -11.73457031 8.363125 -10.72851562 7.90625 C-9.79072266 7.46796875 -8.85292969 7.0296875 -7.88671875 6.578125 C-7.02264404 6.18012695 -6.15856934 5.78212891 -5.26831055 5.37207031 C-2.79384911 3.87530212 -1.69135117 2.30200743 0 0 Z ",
    fill: "#797D7D",
    transform: "translate(406,579)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 4.20410876 -2.21515384 6.11449675 -5 9 C-9.37341225 13.14890443 -13.88909073 16.8056817 -19 20 C-17.62140072 16.80636047 -16.11891172 15.00638231 -13.4375 12.8125 C-8.68723621 8.80310304 -4.34736751 4.43793766 0 0 Z ",
    fill: "#08080A",
    transform: "translate(677,786)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.35716404 2.15454249 3.78966144 4.19719874 5.1875 7.0625 C5.53167969 7.75472656 5.87585938 8.44695313 6.23046875 9.16015625 C7 11 7 11 7 13 C7.66 13.33 8.32 13.66 9 14 C10.10546875 16.1796875 10.10546875 16.1796875 11.1875 18.875 C11.55230469 19.75929688 11.91710937 20.64359375 12.29296875 21.5546875 C13 24 13 24 12 27 C12 26.34 12 25.68 12 25 C11.01 24.67 10.02 24.34 9 24 C8.58281485 22.22696311 8.17501369 20.4513817 7.8046875 18.66796875 C6.53226426 14.44920626 4.43287898 10.63481311 2.38769531 6.74926758 C0 2.18207694 0 2.18207694 0 0 Z ",
    fill: "#7A7C7B",
    transform: "translate(724,558)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1.495 2.01 1.495 1 2 C0.86722656 2.73605469 0.73445313 3.47210937 0.59765625 4.23046875 C-0.12867928 7.59629809 -1.53431933 9.54679908 -3.5625 12.3125 C-4.20316406 13.19550781 -4.84382813 14.07851563 -5.50390625 14.98828125 C-6.24447266 15.98408203 -6.24447266 15.98408203 -7 17 C-7.33 16.34 -7.66 15.68 -8 15 C-6.03390781 9.5386328 -3.178638 4.83705782 0 0 Z ",
    fill: "#353838",
    transform: "translate(437,544)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C0.70125 2.855625 1.4025 2.71125 2.125 2.5625 C5.07556141 1.98521625 8.03270151 1.48304859 11 1 C8.17589976 3.92869654 5.27847819 6.58427923 2 9 C1.34 9 0.68 9 0 9 C0 7.68 0 6.36 0 5 C-1.98 5.99 -1.98 5.99 -4 7 C-2.92598892 4.08482708 -2.22189824 2.22189824 0 0 Z ",
    fill: "#4B4E4F",
    transform: "translate(270,694)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C-4.07710917 6.15125867 -11.38147872 10.69331014 -19 15 C-19 14.01 -19 13.02 -19 12 C-16.60699003 10.35703793 -14.27344648 8.91331661 -11.75 7.5 C-10.38948981 6.72072857 -9.03008293 5.9395272 -7.671875 5.15625 C-7.02927734 4.79015625 -6.38667969 4.4240625 -5.72460938 4.046875 C-3.84258635 2.95576211 -3.84258635 2.95576211 -1.703125 1.15625 C-1.14109375 0.7746875 -0.5790625 0.393125 0 0 Z ",
    fill: "#080809",
    transform: "translate(580,585)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.92599595 1.79575635 10.42775817 5.69404532 13.875 10.75 C14.58333333 12.16666667 15.29166667 13.58333333 16 15 C12.65920823 13.51604921 10.16993656 11.60554454 7.4375 9.1875 C6.67308594 8.52105469 5.90867188 7.85460937 5.12109375 7.16796875 C2.93918826 4.93784435 1.49098725 2.72950701 0 0 Z ",
    fill: "#434746",
    transform: "translate(237,264)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C1.51338102 3.73718325 -2.73141672 6.10190999 -7.0625 8.75 C-7.89072266 9.26949219 -8.71894531 9.78898437 -9.57226562 10.32421875 C-10.36439453 10.81019531 -11.15652344 11.29617188 -11.97265625 11.796875 C-12.69718994 12.24385742 -13.42172363 12.69083984 -14.16821289 13.15136719 C-14.77270264 13.43141602 -15.37719238 13.71146484 -16 14 C-16.66 13.67 -17.32 13.34 -18 13 C-17.0615625 12.44570313 -16.123125 11.89140625 -15.15625 11.3203125 C-13.93727016 10.5889246 -12.71853255 9.85713286 -11.5 9.125 C-10.56994141 8.57779297 -10.56994141 8.57779297 -9.62109375 8.01953125 C-8.04632542 7.0677482 -6.51870947 6.03889741 -5 5 C-5 4.34 -5 3.68 -5 3 C-3.35 2.34 -1.7 1.68 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#838787",
    transform: "translate(592,359)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.65 0.33 -3.3 0.66 -5 1 C-5.33 1.99 -5.66 2.98 -6 4 C-12.375 6.125 -12.375 6.125 -16 5 C-16.33 5.66 -16.66 6.32 -17 7 C-18.65 6.67 -20.3 6.34 -22 6 C-18.51134231 3.6742282 -14.96055189 2.54929156 -11 1.3125 C-9.91332031 0.95575195 -9.91332031 0.95575195 -8.8046875 0.59179688 C-3.36149591 -1.12049864 -3.36149591 -1.12049864 0 0 Z ",
    fill: "#5C6160",
    transform: "translate(792,304)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 3 1 3 0.19555664 4.80932617 C-0.22862549 5.46392822 -0.65280762 6.11853027 -1.08984375 6.79296875 C-1.54423828 7.50517578 -1.99863281 8.21738281 -2.46679688 8.95117188 C-2.95212891 9.68916016 -3.43746094 10.42714844 -3.9375 11.1875 C-4.41896484 11.93708984 -4.90042969 12.68667969 -5.39648438 13.45898438 C-6.5886202 15.3121064 -7.78996652 17.15853466 -9 19 C-10.08784335 15.68604014 -10.07262544 15.16419665 -8.5625 11.75 C-8.046875 10.8425 -7.53125 9.935 -7 9 C-6.34 9 -5.68 9 -5 9 C-4.34 6.69 -3.68 4.38 -3 2 C-2.34 2 -1.68 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#444646",
    transform: "translate(357,616)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.02090685 2.92936422 5.92344194 5.9445442 8.75 9.0625 C9.34296875 9.71347656 9.9359375 10.36445312 10.546875 11.03515625 C12.04761633 13.06438445 12.5825608 14.53381312 13 17 C8.74790208 12.87675353 4.86364295 8.48717034 1 4 C0.01 5.32 -0.98 6.64 -2 8 C-2.66 7.67 -3.32 7.34 -4 7 C-2.68 4.69 -1.36 2.38 0 0 Z ",
    fill: "#F2E55E",
    transform: "translate(680,556)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 1.33 0.02 1.66 -1 2 C-1.33 2.99 -1.66 3.98 -2 5 C-4.21484375 6.640625 -4.21484375 6.640625 -6.9375 8.25 C-8.28134766 9.06210937 -8.28134766 9.06210937 -9.65234375 9.890625 C-10.42707031 10.25671875 -11.20179688 10.6228125 -12 11 C-12.66 10.67 -13.32 10.34 -14 10 C-11.19533807 7.00618646 -8.38815731 4.8006379 -4.875 2.6875 C-4.00617187 2.15511719 -3.13734375 1.62273437 -2.2421875 1.07421875 C-1.50226562 0.71972656 -0.76234375 0.36523438 0 0 Z ",
    fill: "#3E4041",
    transform: "translate(611,348)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.65863505 4.32504836 -4.871041 7.09418825 -8.125 10.25 C-8.68832031 10.80429687 -9.25164063 11.35859375 -9.83203125 11.9296875 C-11.21686028 13.29104485 -12.60783204 14.64614859 -14 16 C-14.66 15.67 -15.32 15.34 -16 15 C-12.04 11.04 -8.08 7.08 -4 3 C-5.32 2.34 -6.64 1.68 -8 1 C-5.23735711 0.40267181 -2.83967231 0 0 0 Z ",
    fill: "#F6EB64",
    transform: "translate(677,785)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-0.76203532 2.53723734 -3.53585152 4.05184161 -6.3125 5.5625 C-7.09818359 6.00013672 -7.88386719 6.43777344 -8.69335938 6.88867188 C-9.45068359 7.29794922 -10.20800781 7.70722656 -10.98828125 8.12890625 C-12.03302612 8.70233765 -12.03302612 8.70233765 -13.09887695 9.28735352 C-15 10 -15 10 -18 9 C-17.01 8.01 -16.02 7.02 -15 6 C-14.34 6.33 -13.68 6.66 -13 7 C-12.67 6.01 -12.34 5.02 -12 4 C-10.01350109 3.44638555 -8.02164108 2.90248863 -6.00390625 2.4765625 C-3.87650862 2.05113661 -3.87650862 2.05113661 -1.625 0.8125 C-1.08875 0.544375 -0.5525 0.27625 0 0 Z ",
    fill: "#696D6D",
    transform: "translate(755,263)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.48062847 5.4534011 -0.27115635 10.64134917 -1.59765625 15.95703125 C-2.12881941 18.30706731 -2.12881941 18.30706731 -2 22 C-3.32 21.01 -4.64 20.02 -6 19 C-5.3503125 17.63875 -5.3503125 17.63875 -4.6875 16.25 C-2.43138679 11.03945282 -1.27675107 5.51447802 0 0 Z ",
    fill: "#878A8B",
    transform: "translate(403,817)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1.75 2 1.75 4 4 C4 8 4 8 2.3125 10.0625 C-0.03597407 12.03014044 -2.25823647 13.62911824 -5 15 C-5.66 14.67 -6.32 14.34 -7 14 C-6.360625 13.38125 -5.72125 12.7625 -5.0625 12.125 C-2.96116416 10.17402388 -2.96116416 10.17402388 -2 8 C-1.34 8 -0.68 8 0 8 C0.98120464 4.94736336 0.98120464 3.05263664 0 0 Z ",
    fill: "#626869",
    transform: "translate(404,532)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.1018884 2.29223175 7.56747142 4.80695016 11 8 C11 8.99 11 9.98 11 11 C8.05043472 9.63055898 5.47531189 8.12169591 3 6 C3 5.34 3 4.68 3 4 C2.01 3.67 1.02 3.34 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#3F4142",
    transform: "translate(678,505)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C2.6328125 3.28515625 2.6328125 3.28515625 3.125 6.0625 C3.29257812 6.98160156 3.46015625 7.90070313 3.6328125 8.84765625 C3.75398438 9.55792969 3.87515625 10.26820313 4 11 C4.66 11 5.32 11 6 11 C4.52307692 17.64615385 4.52307692 17.64615385 1.875 19.4375 C1.25625 19.623125 0.6375 19.80875 0 20 C0 19.34 0 18.68 0 18 C0.99 17.34 1.98 16.68 3 16 C2.7834375 15.09636719 2.566875 14.19273437 2.34375 13.26171875 C2.0653125 12.08222656 1.786875 10.90273438 1.5 9.6875 C1.08234375 7.92986328 1.08234375 7.92986328 0.65625 6.13671875 C0 3 0 3 0 0 Z ",
    fill: "#040607",
    transform: "translate(290,333)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.375 1.5 -1.375 1.5 -3 3 C-3.66 3 -4.32 3 -5 3 C-5 3.66 -5 4.32 -5 5 C-6.65 5.33 -8.3 5.66 -10 6 C-9.67 5.34 -9.34 4.68 -9 4 C-10.65 3.67 -12.3 3.34 -14 3 C-9.12941325 0.48073099 -5.50946709 -0.10395221 0 0 Z ",
    fill: "#686B6B",
    transform: "translate(808,232)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-0.969375 1.95875 -1.93875 1.9175 -2.9375 1.875 C-7.44889724 1.85651067 -11.64837652 2.89482578 -16 4 C-16 4.66 -16 5.32 -16 6 C-18.97 5.505 -18.97 5.505 -22 5 C-18.644661 2.76310733 -15.40369426 1.83264459 -11.5625 0.8125 C-10.55993164 0.52729492 -10.55993164 0.52729492 -9.53710938 0.23632812 C-6.06186139 -0.69706355 -3.41391321 -1.37080403 0 0 Z ",
    fill: "#737878",
    transform: "translate(856,131)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.9075 0.53625 1.815 1.0725 2.75 1.625 C5.82880601 3.35338504 5.82880601 3.35338504 8.375 2.1875 C8.91125 1.795625 9.4475 1.40375 10 1 C9.34 3.31 8.68 5.62 8 8 C7.01 8 6.02 8 5 8 C0 2.65116279 0 2.65116279 0 0 Z ",
    fill: "#515353",
    transform: "translate(252,573)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C-0.89435559 7.36734085 -3.5791704 11.46971215 -7 16 C-7.33 15.34 -7.66 14.68 -8 14 C-6.10564441 8.63265915 -3.4208296 4.53028785 0 0 Z ",
    fill: "#424444",
    transform: "translate(838,318)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-7.05087756 3.98837518 -12.98573769 4.48817841 -21 4 C-17.62239627 1.74826418 -15.01777776 1.1633205 -11.0625 0.3125 C-9.83660156 0.04050781 -8.61070312 -0.23148437 -7.34765625 -0.51171875 C-4.37544136 -0.94523901 -2.76075615 -1.03095906 0 0 Z ",
    fill: "#6C7171",
    transform: "translate(755,315)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.7425 0.0825 1.485 0.165 2.25 0.25 C-0.24824489 3.06158409 -3.028476 4.69837831 -6.3125 6.5 C-7.76849609 7.31210937 -7.76849609 7.31210937 -9.25390625 8.140625 C-10.07761719 8.50671875 -10.90132812 8.8728125 -11.75 9.25 C-12.41 8.92 -13.07 8.59 -13.75 8.25 C-13.75 7.26 -13.75 6.27 -13.75 5.25 C-12.14125 5.12625 -12.14125 5.12625 -10.5 5 C-5.81609319 4.06321864 -4.47924027 0.40720366 0 0 Z ",
    fill: "#5A5E5E",
    transform: "translate(770.75,253.75)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.45375 0.474375 0.9075 0.94875 1.375 1.4375 C2.93258204 3.09027808 2.93258204 3.09027808 5 4 C3.71186658 4.83878455 2.41936744 5.67086783 1.125 6.5 C0.40570313 6.9640625 -0.31359375 7.428125 -1.0546875 7.90625 C-3 9 -3 9 -5 9 C-4.42647107 5.12867972 -2.51295648 2.91827204 0 0 Z ",
    fill: "#5F6261",
    transform: "translate(336,755)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-0.61970793 2.53064939 -3.24501643 4.04969748 -5.875 5.5625 C-6.99455078 6.21895508 -6.99455078 6.21895508 -8.13671875 6.88867188 C-8.85214844 7.29794922 -9.56757812 7.70722656 -10.3046875 8.12890625 C-11.2944458 8.70233765 -11.2944458 8.70233765 -12.30419922 9.28735352 C-12.86381348 9.52252686 -13.42342773 9.7577002 -14 10 C-14.66 9.67 -15.32 9.34 -16 9 C-13.69 7.68 -11.38 6.36 -9 5 C-9.66 4.34 -10.32 3.68 -11 3 C-10.06027344 2.80083984 -10.06027344 2.80083984 -9.1015625 2.59765625 C-8.28429687 2.42105469 -7.46703125 2.24445313 -6.625 2.0625 C-5.40683594 1.80146484 -5.40683594 1.80146484 -4.1640625 1.53515625 C-1.970537 1.07669307 -1.970537 1.07669307 0 0 Z ",
    fill: "#6C7070",
    transform: "translate(554,383)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C1.71439353 2.5306999 -0.57762667 4.04965044 -2.875 5.5625 C-3.52597656 6.00013672 -4.17695312 6.43777344 -4.84765625 6.88867188 C-6.52625497 7.98754836 -8.26023387 9.0007818 -10 10 C-10.66 9.67 -11.32 9.34 -12 9 C-8.52992079 5.12167618 -5.95984441 3.46540858 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#5C5E60",
    transform: "translate(680,303)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.23322844 0.62045463 7.52290295 2.10523559 11.3125 4.0625 C12.38113281 4.61035156 13.44976562 5.15820312 14.55078125 5.72265625 C15.35902344 6.14417969 16.16726563 6.56570312 17 7 C17 7.33 17 7.66 17 8 C11.22826387 7.60869586 8.32741832 7.08700619 4 3 C2.67098936 1.99426222 1.33926199 0.99204592 0 0 Z ",
    fill: "#5B5E5E",
    transform: "translate(246,247)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.35814777 4.0744433 -0.05254238 6.81468116 -1.4375 10.6875 C-1.68048828 11.38939453 -1.92347656 12.09128906 -2.17382812 12.81445312 C-2.7744944 14.54578532 -3.38619719 16.27328137 -4 18 C-4.66 18 -5.32 18 -6 18 C-4.41039668 11.76559832 -2.72399099 5.83712355 0 0 Z ",
    fill: "#0C0D0E",
    transform: "translate(454,710)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.58912412 -0.66436554 4.10857029 -3 6.6875 C-3.556875 7.31011719 -4.11375 7.93273437 -4.6875 8.57421875 C-5.120625 9.04472656 -5.55375 9.51523437 -6 10 C-6.99 9.67 -7.98 9.34 -9 9 C-8.34 6.69 -7.68 4.38 -7 2 C-6.67 2.99 -6.34 3.98 -6 5 C-4.02 3.35 -2.04 1.7 0 0 Z ",
    fill: "#474A4A",
    transform: "translate(409,826)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 3 2 3 2 7 C1.34 7 0.68 7 0 7 C-0.66 10.63 -1.32 14.26 -2 18 C-2.33 18 -2.66 18 -3 18 C-2.57045059 11.74892565 -1.98598493 5.95795479 0 0 Z ",
    fill: "#E9D556",
    transform: "translate(604,804)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 4.27739716 -1.61986276 7.47922192 -4 11 C-6.75 12.5 -6.75 12.5 -9 13 C-7.50923566 9.7173068 -5.61379679 7.06922559 -3.375 4.25 C-2.74335938 3.45078125 -2.11171875 2.6515625 -1.4609375 1.828125 C-0.97882813 1.22484375 -0.49671875 0.6215625 0 0 Z ",
    fill: "#515454",
    transform: "translate(346,742)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.28080392 3.84241177 0.30805584 5.22117203 -1 9 C-1.37531446 11.32694964 -1.71917202 13.65976685 -2 16 C-2.66 16 -3.32 16 -4 16 C-4.33 16.99 -4.66 17.98 -5 19 C-6.4216868 14.73493961 -4.65386682 11.79962257 -3.0625 7.8125 C-2.77181641 7.06291016 -2.48113281 6.31332031 -2.18164062 5.54101562 C-1.46274964 3.69075523 -0.73245347 1.84493352 0 0 Z ",
    fill: "#6C6F6F",
    transform: "translate(467,668)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.34415669 0.48268408 6.21227649 1.65473178 9 5 C10.04349839 6.63978318 11.05607981 8.30094366 12 10 C9.50638429 8.79618552 7.31856917 7.54571278 5 6 C5 5.34 5 4.68 5 4 C4.360625 3.71125 3.72125 3.4225 3.0625 3.125 C1 2 1 2 0 0 Z ",
    fill: "#535655",
    transform: "translate(230,345)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.45890625 0.40992188 0.9178125 0.81984375 1.390625 1.2421875 C2.00421875 1.78101563 2.6178125 2.31984375 3.25 2.875 C3.85328125 3.40867187 4.4565625 3.94234375 5.078125 4.4921875 C6.94738852 6.06234228 6.94738852 6.06234228 9.125 7.0625 C11.50818085 8.25409043 12.54015053 9.8102258 14 12 C13.67 12.66 13.34 13.32 13 14 C9.66863403 12.57646476 7.72335243 10.8664687 5.375 8.125 C4.78460938 7.44695312 4.19421875 6.76890625 3.5859375 6.0703125 C2.08681913 4.11333531 1.01430932 2.23951463 0 0 Z ",
    fill: "#2B2D2C",
    transform: "translate(249,333)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.89203125 0.00902344 1.7840625 0.01804687 2.703125 0.02734375 C3.37859375 0.03894531 4.0540625 0.05054688 4.75 0.0625 C4.42 0.7225 4.09 1.3825 3.75 2.0625 C-1.50530593 3.41001434 -6.86579398 3.15826651 -12.25 3.0625 C-8.04248553 0.25749035 -5.00014586 -0.06579139 0 0 Z ",
    fill: "#4B4F4F",
    transform: "translate(343.25,333.9375)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C-0.06893218 3.03590338 -1.15578488 4.05333942 -2.25 5.0625 C-3.15492188 5.91521484 -3.15492188 5.91521484 -4.078125 6.78515625 C-6 8 -6 8 -8.234375 7.68359375 C-8.81703125 7.45800781 -9.3996875 7.23242188 -10 7 C-9.09325024 6.01164277 -8.17410978 5.03464519 -7.25 4.0625 C-6.73953125 3.51722656 -6.2290625 2.97195313 -5.703125 2.41015625 C-3.80621924 0.83955308 -2.40298839 0.41268714 0 0 Z ",
    fill: "#3A3D3F",
    transform: "translate(596,274)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.54334038 2.89217759 5.54334038 2.89217759 6.84375 6.046875 C7.31761171 8.01200737 7.66767445 10.00604667 8 12 C4.91910327 9.22719294 3.31224548 6.93673644 2 3 C1.34 3 0.68 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#2A2C2D",
    transform: "translate(712,542)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.92989218 1.19982444 -3.86919228 2.38452818 -5.8125 3.5625 C-7.43091797 4.55443359 -7.43091797 4.55443359 -9.08203125 5.56640625 C-12 7 -12 7 -15 6 C-14.38125 5.7525 -13.7625 5.505 -13.125 5.25 C-10.64931313 3.79371361 -10.04874998 2.62187494 -9 0 C-8.34 0.33 -7.68 0.66 -7 1 C-6.67 0.67 -6.34 0.34 -6 0 C-2.35294118 -1.17647059 -2.35294118 -1.17647059 0 0 Z ",
    fill: "#646767",
    transform: "translate(350,512)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-0.2863012 2.36402043 -2.57821749 3.71634274 -4.875 5.0625 C-5.85146484 5.64741211 -5.85146484 5.64741211 -6.84765625 6.24414062 C-8.53065725 7.22444533 -10.26296199 8.11898432 -12 9 C-12.66 8.67 -13.32 8.34 -14 8 C-12.16020175 4.44305672 -10.09463373 3.50018652 -6.4375 2.3125 C-5.65246094 2.08175781 -4.86742187 1.85101563 -4.05859375 1.61328125 C-1.96304025 1.05369869 -1.96304025 1.05369869 0 0 Z ",
    fill: "#6E7271",
    transform: "translate(722,279)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.21386936 3.64160808 0.6674695 4.33165469 -0.9375 7.6875 C-1.31777344 8.49574219 -1.69804688 9.30398437 -2.08984375 10.13671875 C-2.39019531 10.75160156 -2.69054687 11.36648437 -3 12 C-4.2077558 8.37673261 -3.54311128 7.35853631 -2 4 C-2.78375 4.515625 -3.5675 5.03125 -4.375 5.5625 C-5.24125 6.036875 -6.1075 6.51125 -7 7 C-7.66 6.67 -8.32 6.34 -9 6 C-6.03 4.02 -3.06 2.04 0 0 Z ",
    fill: "#858B8B",
    transform: "translate(728,213)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.3 1 6.6 1 10 C1.99 10.33 2.98 10.66 4 11 C2.02 11.66 0.04 12.32 -2 13 C-1.85915204 11.20793453 -1.71216299 9.41635083 -1.5625 7.625 C-1.48128906 6.62726562 -1.40007813 5.62953125 -1.31640625 4.6015625 C-1 2 -1 2 0 0 Z ",
    fill: "#EFE25C",
    transform: "translate(600,823)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C2.66 2 3.32 2 4 2 C5.6875 3.6875 5.6875 3.6875 7 6 C6.6875 8.75 6.6875 8.75 6 11 C3.34730103 8.52414762 1.31989897 6.40973899 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#464949",
    transform: "translate(736,588)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-2.95 7.435 -2.95 7.435 -8 14 C-8.66 13.34 -9.32 12.68 -10 12 C-6.7 8.04 -3.4 4.08 0 0 Z ",
    fill: "#070809",
    transform: "translate(620,546)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.04420651 1.77945087 7.46078487 4.39529673 11 7 C6.35970377 7 4.75581517 6.70428232 1.25 3.4375 C0.5075 2.633125 -0.235 1.82875 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#4B4E4E",
    transform: "translate(667,497)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.6875 0.0625 2.6875 0.0625 6 1 C7.99364654 3.14304124 9.51532107 5.48392907 11 8 C6.40378078 6.5129879 3.53027653 4.20187872 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#595E5D",
    transform: "translate(211,331)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.13677581 1.36372796 9.68147026 3.31131057 14 8 C8.24857558 6.70886391 4.62256741 4.6791863 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#3A3D3E",
    transform: "translate(218,308)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C12.67 0.66 12.34 1.32 12 2 C10.0390625 2.51953125 10.0390625 2.51953125 7.625 2.8125 C6.43777344 2.97685547 6.43777344 2.97685547 5.2265625 3.14453125 C3 3 3 3 0 0 Z ",
    fill: "#050707",
    transform: "translate(194,240)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.90363281 0.33773438 -1.80726563 0.67546875 -2.73828125 1.0234375 C-3.91777344 1.46945312 -5.09726562 1.91546875 -6.3125 2.375 C-8.07013672 3.03628906 -8.07013672 3.03628906 -9.86328125 3.7109375 C-13.08553593 4.91489648 -13.08553593 4.91489648 -16 7 C-16.99 6.34 -17.98 5.68 -19 5 C-16.39985473 3.96772138 -13.79573631 2.94894848 -11.1875 1.9375 C-10.44951172 1.64294922 -9.71152344 1.34839844 -8.95117188 1.04492188 C-3.33984375 -1.11328125 -3.33984375 -1.11328125 0 0 Z ",
    fill: "#7D8383",
    transform: "translate(702,404)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0.33 3.3 0.66 5 1 C5 1.66 5 2.32 5 3 C3.35 3.33 1.7 3.66 0 4 C0 4.99 0 5.98 0 7 C-2.31 7.33 -4.62 7.66 -7 8 C-4.47211993 5.20127563 -2.79588866 3.54226981 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#616465",
    transform: "translate(536,371)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.9375 2.8125 1.9375 2.8125 1 5 C-2.375 6.8125 -2.375 6.8125 -6 8 C-6.99 7.67 -7.98 7.34 -9 7 C-8.360625 6.71125 -7.72125 6.4225 -7.0625 6.125 C-4.84793921 5.17176549 -4.84793921 5.17176549 -4 3 C-3.34 3 -2.68 3 -2 3 C-2 2.34 -2 1.68 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#54595A",
    transform: "translate(316,524)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C-1.31 4.97 -3.62 7.94 -6 11 C-6 7.69747512 -5.46920223 5.93840447 -4 3 C-1.875 1.1875 -1.875 1.1875 0 0 Z ",
    fill: "#5C6060",
    transform: "translate(828,335)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-1.41478135 3.64995297 -2.83191487 4.29478722 -4.25 4.9375 C-5.43335938 5.47697266 -5.43335938 5.47697266 -6.640625 6.02734375 C-8.75823698 6.90033279 -10.76669362 7.51338508 -13 8 C-9.24389454 3.96566451 -5.51298111 1.02092243 0 0 Z ",
    fill: "#535758",
    transform: "translate(604,334)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 3 2 3 2 5 C1.34 5 0.68 5 0 5 C-0.33 5.99 -0.66 6.98 -1 8 C-1.99 8 -2.98 8 -4 8 C-3.40072174 4.64404172 -2.15377564 2.62198774 0 0 Z ",
    fill: "#575959",
    transform: "translate(536,897)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.67034745 -1.0752892 5.0999431 -3 8.1875 C-3.556875 9.08855469 -4.11375 9.98960937 -4.6875 10.91796875 C-5.120625 11.60503906 -5.55375 12.29210937 -6 13 C-7 11 -7 11 -6.375 8.1875 C-4.81868604 4.57968127 -2.90663822 2.6006763 0 0 Z ",
    fill: "#6F706F",
    transform: "translate(269,561)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 2 -0.32 2 -1 2 C-1.33 2.99 -1.66 3.98 -2 5 C-4.3125 6.8125 -4.3125 6.8125 -7 8 C-9.3125 7.1875 -9.3125 7.1875 -11 6 C-10.67 5.34 -10.34 4.68 -10 4 C-8.68 4 -7.36 4 -6 4 C-2.78170896 2.07706482 -2.78170896 2.07706482 0 0 Z ",
    fill: "#050A0B",
    transform: "translate(282,356)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C11.33 0.66 11.66 1.32 12 2 C3.57142857 3.28571429 3.57142857 3.28571429 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#353839",
    transform: "translate(689,326)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-4.455 2.97 -4.455 2.97 -9 6 C-9.66 5.67 -10.32 5.34 -11 5 C-4.92783505 -1.23195876 -4.92783505 -1.23195876 0 0 Z ",
    fill: "#525657",
    transform: "translate(719,221)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.32 0.66 2.64 1 4 C0.01 4.495 0.01 4.495 -1 5 C-1.33 5.99 -1.66 6.98 -2 8 C-2.66 8 -3.32 8 -4 8 C-4.25 5.6875 -4.25 5.6875 -4 3 C-2 1.1875 -2 1.1875 0 0 Z ",
    fill: "#25292A",
    transform: "translate(541,892)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.66654496 4.59007126 -0.8943231 7.79570907 -3 11 C-3.33 11 -3.66 11 -4 11 C-3.67 8.69 -3.34 6.38 -3 4 C-2.34 4 -1.68 4 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#4D5050",
    transform: "translate(719,769)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.50769231 1.35384615 7.50769231 1.35384615 10 4.625 C10.495 5.800625 10.495 5.800625 11 7 C10.01 7 9.02 7 8 7 C8 6.34 8 5.68 8 5 C6.8553125 4.5978125 6.8553125 4.5978125 5.6875 4.1875 C3.12619116 3.05575888 1.80307062 2.08776599 0 0 Z ",
    fill: "#5A5D5D",
    transform: "translate(200,324)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.66 0.66 -1.32 1.32 -2 2 C-1.01 2.66 -0.02 3.32 1 4 C-2.63 3.67 -6.26 3.34 -10 3 C-9 1 -9 1 -7.25 0.375 C-4.79549443 -0.03408426 -2.4840589 -0.06900164 0 0 Z ",
    fill: "#040607",
    transform: "translate(117,287)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C5.6875 2.5 5.6875 2.5 3 5 C2.01 5 1.02 5 0 5 C0.33 4.34 0.66 3.68 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#515858",
    transform: "translate(658,832)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C1.74194623 4.50802601 0.09592835 7.4912812 -3 11 C-3.33 9.68 -3.66 8.36 -4 7 C-3.01 6.34 -2.02 5.68 -1 5 C-0.27034634 2.43717258 -0.27034634 2.43717258 0 0 Z ",
    fill: "#525657",
    transform: "translate(507,652)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.26493447 3.79480342 0.89988258 6.12358274 0 10 C-2.0625 11.9375 -2.0625 11.9375 -4 13 C-3.40895235 8.15340923 -2.02055843 4.39251833 0 0 Z ",
    fill: "#676C6C",
    transform: "translate(399,634)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C8.67 1.65 8.34 3.3 8 5 C7.67 4.01 7.34 3.02 7 2 C4.36 2 1.72 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#7A7C7C",
    transform: "translate(459,549)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-3.14573677 2.09715785 -5.01456251 2.52004559 -8.6875 3.125 C-9.68136719 3.29257812 -10.67523437 3.46015625 -11.69921875 3.6328125 C-12.45847656 3.75398438 -13.21773437 3.87515625 -14 4 C-12.63215249 1.26430498 -10.66237461 0.66368786 -7.921875 -0.46875 C-5.09100878 -1.25126587 -2.79298073 -0.74933629 0 0 Z ",
    fill: "#888B8C",
    transform: "translate(532,399)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.2626876 3.08632611 6.02235218 5.93483504 8 10 C7.67 10.66 7.34 11.32 7 12 C2.96950775 8.37255698 1.68106821 5.04320462 0 0 Z ",
    fill: "#3C3F3F",
    transform: "translate(262,286)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-2.455 4.465 -2.455 4.465 -7 8 C-7.66 7.67 -8.32 7.34 -9 7 C-8 4 -8 4 -6.1875 2.9375 C-5.465625 2.628125 -4.74375 2.31875 -4 2 C-3.29875 1.608125 -2.5975 1.21625 -1.875 0.8125 C-1.25625 0.544375 -0.6375 0.27625 0 0 Z ",
    fill: "#606465",
    transform: "translate(663,257)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 2.66053211 -0.19335496 4.49940039 -1 7 C-3 9 -3 9 -6 10 C-4.6302836 6.00499382 -2.74277578 3.19990508 0 0 Z ",
    fill: "#555A5B",
    transform: "translate(279,681)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2 2 -2 2 -4.1640625 2.1953125 C-5.38222656 2.16050781 -5.38222656 2.16050781 -6.625 2.125 C-7.44226563 2.10695313 -8.25953125 2.08890625 -9.1015625 2.0703125 C-9.72804688 2.04710937 -10.35453125 2.02390625 -11 2 C-11 1.34 -11 0.68 -11 0 C-6.94952424 -1.35015859 -4.2079832 -0.62084998 0 0 Z ",
    fill: "#5D6263",
    transform: "translate(662,400)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.08035356 3.08035356 4.06916801 6.81125605 5 11 C4.566875 10.505 4.13375 10.01 3.6875 9.5 C2.00259517 7.66781808 2.00259517 7.66781808 -1 8 C-0.67 7.01 -0.34 6.02 0 5 C-0.31478446 3.66216607 -0.64587656 2.32796291 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#616868",
    transform: "translate(275,302)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.29557392 5.02475668 1.0282379 7.92352591 -2 12 C-2.66 12.66 -3.32 13.32 -4 14 C-3.36843005 8.94744036 -1.86540627 4.70406799 0 0 Z ",
    fill: "#727677",
    transform: "translate(846,235)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.65 1.65 -3.3 3.3 -5 5 C-7.475 4.01 -7.475 4.01 -10 3 C-6.68152292 -0.06320961 -4.44849969 -0.3033068 0 0 Z ",
    fill: "#08090A",
    transform: "translate(800,235)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.18451025 9.41002278 1.18451025 9.41002278 0 14 C-0.28875 13.360625 -0.5775 12.72125 -0.875 12.0625 C-1.82823451 9.84793921 -1.82823451 9.84793921 -4 9 C-4 8.34 -4 7.68 -4 7 C-3.01 7 -2.02 7 -1 7 C-0.67 4.69 -0.34 2.38 0 0 Z ",
    fill: "#7B8181",
    transform: "translate(860,171)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 2 1 2 0.375 5 C-1 8 -1 8 -3.625 9.375 C-4.40875 9.58125 -5.1925 9.7875 -6 10 C-4.34832443 6.4213696 -2.21713508 3.25179812 0 0 Z ",
    fill: "#5B5E5F",
    transform: "translate(290,665)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.75 2 -1.75 2 -4 4 C-5.32 4 -6.64 4 -8 4 C-8.33 3.01 -8.66 2.02 -9 1 C-6.04335481 -0.4783226 -3.25770263 -0.06032783 0 0 Z ",
    fill: "#101A1D",
    transform: "translate(678,440)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.45264038 0.8638129 -2.9123163 1.71580454 -4.375 2.5625 C-5.59316406 3.27599609 -5.59316406 3.27599609 -6.8359375 4.00390625 C-7.55007813 4.33261719 -8.26421875 4.66132813 -9 5 C-9.66 4.67 -10.32 4.34 -11 4 C-8.54493529 0.31740294 -4.36534139 -2.1826707 0 0 Z ",
    fill: "#5D6362",
    transform: "translate(574,374)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-4.62 1.33 -9.24 1.66 -14 2 C-9.46904529 -2.53095471 -5.68350805 -2.84175403 0 0 Z ",
    fill: "#75787A",
    transform: "translate(649,332)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.2077558 3.62326739 0.54311128 4.64146369 -1 8 C-1.66 8 -2.32 8 -3 8 C-3.33 8.99 -3.66 9.98 -4 11 C-4.33 10.34 -4.66 9.68 -5 9 C-4.0625 6.375 -4.0625 6.375 -3 4 C-2.34 4 -1.68 4 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#464849",
    transform: "translate(873,250)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.3340394 4.00211819 0.40012984 6.07963644 -1 10 C-2.625 11.9375 -2.625 11.9375 -4 13 C-3.27991594 8.39146203 -1.68704061 4.32762591 0 0 Z ",
    fill: "#686C6E",
    transform: "translate(717,241)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.4375 2.9375 1.4375 2.9375 0 5 C-3.625 5.75 -3.625 5.75 -7 6 C-4.74259377 3.66475218 -2.7194239 1.81294927 0 0 Z ",
    fill: "#515658",
    transform: "translate(685,203)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.97 1 5.94 1 9 C0.01 9 -0.98 9 -2 9 C-2 8.01 -2 7.02 -2 6 C-2.66 5.67 -3.32 5.34 -4 5 C-3.01 5 -2.02 5 -1 5 C-0.67 3.35 -0.34 1.7 0 0 Z ",
    fill: "#545757",
    transform: "translate(460,687)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.32 0.66 2.64 1 4 C-1.375 5.5625 -1.375 5.5625 -4 7 C-4.66 6.67 -5.32 6.34 -6 6 C-4.02 4.02 -2.04 2.04 0 0 Z ",
    fill: "#343636",
    transform: "translate(332,649)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 3 1 3 0.00390625 5.04296875 C-0.47175781 5.75066406 -0.94742187 6.45835937 -1.4375 7.1875 C-1.91058594 7.90292969 -2.38367188 8.61835937 -2.87109375 9.35546875 C-3.24363281 9.89816406 -3.61617188 10.44085937 -4 11 C-5.60031344 7.79937313 -4.03173691 5.27728194 -3 2 C-2.34 2 -1.68 2 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#646868",
    transform: "translate(357,616)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.86214442 5.0940919 6.86214442 5.0940919 7.4375 8.875 C7.293125 9.57625 7.14875 10.2775 7 11 C4.08156555 8.373409 2.05482685 5.33023661 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#6D7271",
    transform: "translate(397,521)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.29223784 -0.50518132 5.08510357 -2 8 C-4.125 9.3125 -4.125 9.3125 -6 10 C-4.6302836 6.00499382 -2.74277578 3.19990508 0 0 Z ",
    fill: "#6F7474",
    transform: "translate(249,389)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2 1.66 2 2.32 2 3 C0.03852126 4.38938077 -1.96166576 5.7260411 -4 7 C-3.67 5.02 -3.34 3.04 -3 1 C-2.01 0.67 -1.02 0.34 0 0 Z ",
    fill: "#E3C049",
    transform: "translate(321,383)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.93254772 2.0245738 -3.63158688 3.42105792 -6 5 C-8.1875 4.625 -8.1875 4.625 -10 4 C-6.64324136 0.64324136 -4.66293682 -0.25205064 0 0 Z ",
    fill: "#4F5253",
    transform: "translate(597,359)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.31038651 1.65519326 3.78867011 4.65442221 5 8 C4.67 8.99 4.34 9.98 4 11 C3.71125 10.360625 3.4225 9.72125 3.125 9.0625 C2.17176549 6.84793921 2.17176549 6.84793921 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#646867",
    transform: "translate(303,298)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.59915881 0.69906942 -3.20455045 1.38389468 -4.8125 2.0625 C-5.70582031 2.44535156 -6.59914063 2.82820312 -7.51953125 3.22265625 C-10 4 -10 4 -13 3 C-8.83099908 0.22066605 -4.8978425 -1.63261417 0 0 Z ",
    fill: "#7C8180",
    transform: "translate(857,159)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.39195915 4.17587745 -0.17676781 6.13474776 -2 10 C-2.33 10 -2.66 10 -3 10 C-3.36923077 3.47692308 -3.36923077 3.47692308 -1.5 1.0625 C-1.005 0.711875 -0.51 0.36125 0 0 Z ",
    fill: "#5B5E5E",
    transform: "translate(491,688)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-1.96 4.465 -1.96 4.465 -6 8 C-6.66 7.67 -7.32 7.34 -8 7 C-5.36 4.69 -2.72 2.38 0 0 Z ",
    fill: "#0B0A08",
    transform: "translate(641,603)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.99 1.98 1.98 3 3 C2.67 3.66 2.34 4.32 2 5 C1.34 5 0.68 5 0 5 C-0.99 6.485 -0.99 6.485 -2 8 C-2.66 7.67 -3.32 7.34 -4 7 C-2.68 4.69 -1.36 2.38 0 0 Z ",
    fill: "#E9DA5D",
    transform: "translate(680,556)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0.495 2.97 0.495 6 1 C3.37801226 3.15377564 1.35595828 4.40072174 -2 5 C-1.34 3.35 -0.68 1.7 0 0 Z ",
    fill: "#4A4E4E",
    transform: "translate(290,536)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 2 1 2 0.3125 5 C-1 8 -1 8 -3.125 9.375 C-3.74375 9.58125 -4.3625 9.7875 -5 10 C-3.66511872 6.40608886 -2.03977277 3.24509304 0 0 Z ",
    fill: "#5F6261",
    transform: "translate(550,875)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C1.66 7 2.32 7 3 7 C3 7.66 3 8.32 3 9 C1.68 8.67 0.36 8.34 -1 8 C-0.67 5.36 -0.34 2.72 0 0 Z ",
    fill: "#04050A",
    transform: "translate(597,829)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.875 0.8125 1.875 0.8125 3.875 2.8125 C0.575 2.8125 -2.725 2.8125 -6.125 2.8125 C-2.125 -0.1875 -2.125 -0.1875 0 0 Z ",
    fill: "#9C9F9E",
    transform: "translate(633.125,393.1875)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0.33 3.3 0.66 5 1 C2.64722731 3.72426311 0.37503669 4.8141763 -3 6 C-2.01 4.02 -1.02 2.04 0 0 Z ",
    fill: "#575C5D",
    transform: "translate(687,297)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-0.64 2.65 -3.28 4.3 -6 6 C-6.66 5.34 -7.32 4.68 -8 4 C-6.71349294 3.30289269 -5.42059335 2.61757124 -4.125 1.9375 C-3.40570312 1.55464844 -2.68640625 1.17179688 -1.9453125 0.77734375 C-1.30335938 0.52082031 -0.66140625 0.26429688 0 0 Z ",
    fill: "#616463",
    transform: "translate(744,170)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-2.97 2.505 -2.97 2.505 -6 2 C-6 1.34 -6 0.68 -6 0 C-3 -1 -3 -1 0 0 Z M0 1 C2 2 2 2 2 2 Z ",
    fill: "#3F4546",
    transform: "translate(804,147)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.33 1.98 2.66 3.96 3 6 C2.01 6 1.02 6 0 6 C-0.66 5.34 -1.32 4.68 -2 4 C-1.34 2.68 -0.68 1.36 0 0 Z ",
    fill: "#797A7B",
    transform: "translate(399,832)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C1.75023244 3.65316671 1.32901247 4.78065836 -2 7 C-1.34 4.69 -0.68 2.38 0 0 Z ",
    fill: "#585C5C",
    transform: "translate(431,554)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 0.99 -0.66 1.98 -1 3 C-1.66 3 -2.32 3 -3 3 C-3 3.66 -3 4.32 -3 5 C-4.32 5.33 -5.64 5.66 -7 6 C-5.52522876 2.59668175 -4.14385429 0 0 0 Z ",
    fill: "#0B0B0C",
    transform: "translate(337,480)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.34058637 2.12780579 3.70700306 4.11562221 5 7 C4.01 8.485 4.01 8.485 3 10 C2.49596232 8.70990357 1.99690074 7.41786211 1.5 6.125 C1.2215625 5.40570313 0.943125 4.68640625 0.65625 3.9453125 C0 2 0 2 0 0 Z ",
    fill: "#2E3131",
    transform: "translate(278,307)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C1.81323934 4.10801767 1.10551666 5.89448334 -2 9 C-1.34 6.03 -0.68 3.06 0 0 Z ",
    fill: "#636767",
    transform: "translate(852,293)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.5 2.3125 2.5 2.3125 5 5 C5 5.99 5 6.98 5 8 C2.21611025 6.29374499 1.14615794 5.52373261 0.25 2.3125 C0.1675 1.549375 0.085 0.78625 0 0 Z ",
    fill: "#5F6262",
    transform: "translate(289,277)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C-0.0625 5.1875 -0.0625 5.1875 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#4A4E4F",
    transform: "translate(522,592)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C3.33 1.99 3.66 2.98 4 4 C3.01 3.67 2.02 3.34 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#4A5051",
    transform: "translate(139,300)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C3.01 1.33 2.02 1.66 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#485051",
    transform: "translate(410,608)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.99 0 1.98 0 3 C-0.66 3 -1.32 3 -2 3 C-2 2.34 -2 1.68 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#4B5355",
    transform: "translate(580,384)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.485 0.99 1.485 0.99 3 2 C2.01 2 1.02 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#444A4C",
    transform: "translate(470,610)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C1.34 3.67 0.68 3.34 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#434B4B",
    transform: "translate(400,531)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 2.66 -0.32 3.32 -1 4 C-0.67 2.68 -0.34 1.36 0 0 Z ",
    fill: "#42494C",
    transform: "translate(681,201)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 1 0.02 1 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#4F5456",
    transform: "translate(545,873)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#4C5150",
    transform: "translate(568,753)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#484F52",
    transform: "translate(472,644)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.01 2.495 1.01 2.495 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#484F4E",
    transform: "translate(312,618)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 1 0.02 1 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#424B4D",
    transform: "translate(449,577)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#464E4F",
    transform: "translate(376,552)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#3F484C",
    transform: "translate(444,550)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 0 3 Z ",
    fill: "#41484D",
    transform: "translate(401,537)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#485052",
    transform: "translate(585,464)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 1 0.02 1 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#44494B",
    transform: "translate(739,422)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.66 1.34 2.32 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#41484A",
    transform: "translate(248,363)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#464F50",
    transform: "translate(663,360)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.485 0.99 1.485 0.99 3 2 C2.01 2 1.02 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#454C4E",
    transform: "translate(466,354)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#43494C",
    transform: "translate(288,338)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#434A4C",
    transform: "translate(784,333)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C2.67 0.66 2.34 1.32 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#414A4C",
    transform: "translate(624,316)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 1.485 0.99 1.485 2 3 C1.34 3 0.68 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#4D5455",
    transform: "translate(759,241)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.66 2 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#42494B",
    transform: "translate(720,225)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#40484A",
    transform: "translate(658,216)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.66 1.34 2.32 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#3E4749",
    transform: "translate(696,192)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#4A4F52",
    transform: "translate(895,160)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#454C4F",
    transform: "translate(755,161)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#4C5052",
    transform: "translate(407,831)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#4D5354",
    transform: "translate(569,817)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#4E5456",
    transform: "translate(417,776)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5050",
    transform: "translate(0,0)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#4E5658",
    transform: "translate(432,759)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5356",
    transform: "translate(0,0)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#4F5355",
    transform: "translate(272,687)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#4F5253",
    transform: "translate(384,665)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#494E51",
    transform: "translate(464,664)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F4F",
    transform: "translate(0,0)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474E51",
    transform: "translate(0,0)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#494F50",
    transform: "translate(305,632)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C4E",
    transform: "translate(0,0)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F51",
    transform: "translate(0,0)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485051",
    transform: "translate(0,0)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#4C4F51",
    transform: "translate(523,605)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#444D4E",
    transform: "translate(443,584)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#55595A",
    transform: "translate(261,582)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#4B5154",
    transform: "translate(336,576)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#485152",
    transform: "translate(362,560)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#464C4C",
    transform: "translate(232,549)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#474C4E",
    transform: "translate(232,546)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#494E50",
    transform: "translate(224,525)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#454D4E",
    transform: "translate(331,522)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#464F52",
    transform: "translate(647,480)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#495052",
    transform: "translate(604,465)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#4A5154",
    transform: "translate(598,466)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#474D4E",
    transform: "translate(586,454)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#4B5254",
    transform: "translate(606,453)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#464C4E",
    transform: "translate(602,453)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#4C5454",
    transform: "translate(640,416)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#4A5252",
    transform: "translate(594,406)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#414A4B",
    transform: "translate(537,368)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#444D4F",
    transform: "translate(423,360)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#424E50",
    transform: "translate(461,353)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#4A5355",
    transform: "translate(644,350)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#4B5555",
    transform: "translate(641,350)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#424C4E",
    transform: "translate(580,344)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#484E50",
    transform: "translate(739,341)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#41494A",
    transform: "translate(830,339)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E474B",
    transform: "translate(0,0)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#42494A",
    transform: "translate(322,336)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#4B5253",
    transform: "translate(365,332)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#40494A",
    transform: "translate(600,329)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D4649",
    transform: "translate(0,0)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#474E4F",
    transform: "translate(177,314)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#495152",
    transform: "translate(776,304)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#454B4F",
    transform: "translate(148,302)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#3C4447",
    transform: "translate(563,298)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#545759",
    transform: "translate(111,293)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#535757",
    transform: "translate(105,292)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#444A4D",
    transform: "translate(868,270)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#474D50",
    transform: "translate(232,267)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#444B4E",
    transform: "translate(704,265)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#474E4E",
    transform: "translate(876,254)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#3E4849",
    transform: "translate(624,242)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#414A4C",
    transform: "translate(727,176)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454E50",
    transform: "translate(0,0)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#454D50",
    transform: "translate(816,174)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#444E4E",
    transform: "translate(821,172)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#444A4D",
    transform: "translate(739,168)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#4C5254",
    transform: "translate(873,122)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#585A59",
    transform: "translate(0,0)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#474B4A",
    transform: "translate(579,886)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5052",
    transform: "translate(0,0)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5051",
    transform: "translate(0,0)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#464D4C",
    transform: "translate(653,847)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5254",
    transform: "translate(0,0)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5253",
    transform: "translate(0,0)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#545B5A",
    transform: "translate(0,0)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5456",
    transform: "translate(0,0)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5254",
    transform: "translate(0,0)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#5A5D5C",
    transform: "translate(328,764)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5050",
    transform: "translate(0,0)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5455",
    transform: "translate(0,0)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444A4C",
    transform: "translate(0,0)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5352",
    transform: "translate(0,0)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484D50",
    transform: "translate(0,0)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4C5153",
    transform: "translate(378,733)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#494E50",
    transform: "translate(390,721)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#484F50",
    transform: "translate(398,714)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5455",
    transform: "translate(0,0)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505556",
    transform: "translate(0,0)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484D4D",
    transform: "translate(0,0)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4F51",
    transform: "translate(0,0)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5356",
    transform: "translate(0,0)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4B5153",
    transform: "translate(368,701)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495254",
    transform: "translate(0,0)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5152",
    transform: "translate(0,0)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#515355",
    transform: "translate(272,683)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464A4C",
    transform: "translate(0,0)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D4C",
    transform: "translate(0,0)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F4F",
    transform: "translate(0,0)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4B5353",
    transform: "translate(288,657)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4B5253",
    transform: "translate(385,656)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484C4F",
    transform: "translate(0,0)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485050",
    transform: "translate(0,0)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485050",
    transform: "translate(0,0)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494D50",
    transform: "translate(0,0)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464D4B",
    transform: "translate(0,0)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5253",
    transform: "translate(0,0)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414749",
    transform: "translate(0,0)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F50",
    transform: "translate(0,0)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F4F",
    transform: "translate(0,0)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5251",
    transform: "translate(0,0)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C4F",
    transform: "translate(0,0)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#494E50",
    transform: "translate(321,600)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#454A4F",
    transform: "translate(372,599)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#494F51",
    transform: "translate(379,597)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F51",
    transform: "translate(0,0)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464F4F",
    transform: "translate(0,0)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#444B4F",
    transform: "translate(440,585)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#474C50",
    transform: "translate(413,583)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5253",
    transform: "translate(0,0)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F4F",
    transform: "translate(0,0)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#474D4E",
    transform: "translate(419,574)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444C50",
    transform: "translate(0,0)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5054",
    transform: "translate(0,0)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#434A4B",
    transform: "translate(429,563)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#424B4C",
    transform: "translate(456,561)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#474F51",
    transform: "translate(384,552)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#454D4D",
    transform: "translate(523,551)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5153",
    transform: "translate(0,0)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#454C4D",
    transform: "translate(402,535)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5053",
    transform: "translate(0,0)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#424A4C",
    transform: "translate(397,526)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#464E4C",
    transform: "translate(700,521)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#464E50",
    transform: "translate(392,521)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#46494B",
    transform: "translate(338,519)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C4F",
    transform: "translate(0,0)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#434B4D",
    transform: "translate(384,503)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5154",
    transform: "translate(0,0)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5153",
    transform: "translate(0,0)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454B4D",
    transform: "translate(0,0)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5252",
    transform: "translate(0,0)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#484D4E",
    transform: "translate(629,474)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#44494E",
    transform: "translate(623,473)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5151",
    transform: "translate(0,0)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#495052",
    transform: "translate(579,455)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4B5254",
    transform: "translate(590,454)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#494E51",
    transform: "translate(700,439)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484D51",
    transform: "translate(0,0)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454D4E",
    transform: "translate(0,0)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444B4D",
    transform: "translate(0,0)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5052",
    transform: "translate(0,0)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4A4F51",
    transform: "translate(603,420)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5356",
    transform: "translate(0,0)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4C5354",
    transform: "translate(632,417)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4C5455",
    transform: "translate(608,417)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#454D4D",
    transform: "translate(756,415)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#484E4E",
    transform: "translate(232,412)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#515659",
    transform: "translate(680,408)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4A4D50",
    transform: "translate(588,407)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5759",
    transform: "translate(0,0)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#464C50",
    transform: "translate(240,397)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#485153",
    transform: "translate(711,394)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4F5756",
    transform: "translate(541,394)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E51",
    transform: "translate(0,0)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5455",
    transform: "translate(0,0)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4C5356",
    transform: "translate(582,385)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434849",
    transform: "translate(0,0)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4B5052",
    transform: "translate(668,383)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5154",
    transform: "translate(0,0)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444C4E",
    transform: "translate(0,0)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5252",
    transform: "translate(0,0)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#495055",
    transform: "translate(619,376)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#485053",
    transform: "translate(602,376)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#41484B",
    transform: "translate(538,370)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#495254",
    transform: "translate(634,368)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404A4C",
    transform: "translate(0,0)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444A4C",
    transform: "translate(0,0)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#464C4F",
    transform: "translate(545,365)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5355",
    transform: "translate(0,0)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414A4E",
    transform: "translate(0,0)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#434C4C",
    transform: "translate(428,361)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#495153",
    transform: "translate(657,360)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#42494C",
    transform: "translate(490,360)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#444F50",
    transform: "translate(430,360)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#404A4A",
    transform: "translate(496,357)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#474E4E",
    transform: "translate(475,356)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495154",
    transform: "translate(0,0)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#414A4E",
    transform: "translate(768,352)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D51",
    transform: "translate(0,0)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444A4D",
    transform: "translate(0,0)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#40484C",
    transform: "translate(512,344)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454C4E",
    transform: "translate(0,0)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F51",
    transform: "translate(0,0)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#444B4D",
    transform: "translate(756,338)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#42494A",
    transform: "translate(262,338)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3D464B",
    transform: "translate(259,338)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E474B",
    transform: "translate(0,0)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474E51",
    transform: "translate(0,0)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#475051",
    transform: "translate(0,0)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4B5252",
    transform: "translate(656,328)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#40494A",
    transform: "translate(607,328)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3D4447",
    transform: "translate(529,328)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3E4649",
    transform: "translate(838,327)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#485151",
    transform: "translate(648,327)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485155",
    transform: "translate(0,0)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434B4C",
    transform: "translate(0,0)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444C4E",
    transform: "translate(0,0)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40464A",
    transform: "translate(0,0)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#474F51",
    transform: "translate(181,319)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3E454A",
    transform: "translate(544,314)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464E50",
    transform: "translate(0,0)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454C4E",
    transform: "translate(0,0)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#474C51",
    transform: "translate(169,311)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#464F52",
    transform: "translate(678,309)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5051",
    transform: "translate(0,0)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D4749",
    transform: "translate(0,0)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E4449",
    transform: "translate(0,0)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3A4247",
    transform: "translate(569,293)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#464C4F",
    transform: "translate(197,292)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E464A",
    transform: "translate(0,0)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424649",
    transform: "translate(0,0)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F474A",
    transform: "translate(0,0)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#434C4F",
    transform: "translate(248,279)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C4B",
    transform: "translate(0,0)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4A5354",
    transform: "translate(747,270)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B4348",
    transform: "translate(0,0)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485052",
    transform: "translate(0,0)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#424C4F",
    transform: "translate(704,257)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#495154",
    transform: "translate(832,256)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3D4449",
    transform: "translate(608,256)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#494F51",
    transform: "translate(217,255)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5458",
    transform: "translate(0,0)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#404649",
    transform: "translate(675,251)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#525554",
    transform: "translate(209,251)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434C4E",
    transform: "translate(0,0)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F52",
    transform: "translate(0,0)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474E50",
    transform: "translate(0,0)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#4D5457",
    transform: "translate(241,241)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3F474A",
    transform: "translate(624,240)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#495252",
    transform: "translate(230,240)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#484F50",
    transform: "translate(843,237)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3E474A",
    transform: "translate(633,237)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#565859",
    transform: "translate(195,237)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3F4A4A",
    transform: "translate(648,224)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5155",
    transform: "translate(0,0)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40474B",
    transform: "translate(0,0)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#434B4E",
    transform: "translate(713,184)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#494D50",
    transform: "translate(802,180)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#454B4C",
    transform: "translate(721,179)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4E50",
    transform: "translate(0,0)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#434B4D",
    transform: "translate(737,170)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E52",
    transform: "translate(0,0)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474F51",
    transform: "translate(0,0)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#484F50",
    transform: "translate(790,148)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444D51",
    transform: "translate(0,0)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424140",
    transform: "translate(0,0)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515152",
    transform: "translate(0,0)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#514F50",
    transform: "translate(0,0)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5050",
    transform: "translate(0,0)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464645",
    transform: "translate(0,0)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#50514F",
    transform: "translate(0,0)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4F4E",
    transform: "translate(0,0)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4F50",
    transform: "translate(0,0)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444341",
    transform: "translate(0,0)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525051",
    transform: "translate(0,0)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424242",
    transform: "translate(0,0)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#403F3E",
    transform: "translate(0,0)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40403E",
    transform: "translate(0,0)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4A49",
    transform: "translate(0,0)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#545552",
    transform: "translate(0,0)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5050",
    transform: "translate(0,0)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525354",
    transform: "translate(0,0)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505051",
    transform: "translate(0,0)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525452",
    transform: "translate(0,0)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#504F50",
    transform: "translate(0,0)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#545756",
    transform: "translate(0,0)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444241",
    transform: "translate(0,0)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474544",
    transform: "translate(0,0)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#535556",
    transform: "translate(0,0)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#545857",
    transform: "translate(0,0)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525353",
    transform: "translate(0,0)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505152",
    transform: "translate(0,0)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4C4E",
    transform: "translate(0,0)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4A4B",
    transform: "translate(0,0)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#423F3F",
    transform: "translate(0,0)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4E4D",
    transform: "translate(0,0)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#535555",
    transform: "translate(0,0)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#545756",
    transform: "translate(0,0)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515251",
    transform: "translate(0,0)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505150",
    transform: "translate(0,0)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#585B5B",
    transform: "translate(0,0)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#55565D",
    transform: "translate(0,0)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505357",
    transform: "translate(0,0)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#555B5A",
    transform: "translate(0,0)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4A49",
    transform: "translate(0,0)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#545457",
    transform: "translate(0,0)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#555555",
    transform: "translate(0,0)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#575A5B",
    transform: "translate(0,0)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#575B5B",
    transform: "translate(0,0)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#585C5C",
    transform: "translate(0,0)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#565656",
    transform: "translate(0,0)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5454",
    transform: "translate(0,0)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5253",
    transform: "translate(0,0)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#545959",
    transform: "translate(0,0)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4F52",
    transform: "translate(0,0)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525755",
    transform: "translate(0,0)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495053",
    transform: "translate(0,0)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444A4B",
    transform: "translate(0,0)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4F4F",
    transform: "translate(0,0)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C494B",
    transform: "translate(0,0)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E4F",
    transform: "translate(0,0)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4E4F",
    transform: "translate(0,0)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4E50",
    transform: "translate(0,0)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E4E",
    transform: "translate(0,0)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5256",
    transform: "translate(0,0)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4E4F",
    transform: "translate(0,0)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424748",
    transform: "translate(0,0)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4E50",
    transform: "translate(0,0)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5154",
    transform: "translate(0,0)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F4D",
    transform: "translate(0,0)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3D41",
    transform: "translate(0,0)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505352",
    transform: "translate(0,0)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43484A",
    transform: "translate(0,0)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5151",
    transform: "translate(0,0)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505153",
    transform: "translate(0,0)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444443",
    transform: "translate(0,0)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#49504F",
    transform: "translate(0,0)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414549",
    transform: "translate(0,0)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484C51",
    transform: "translate(0,0)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424647",
    transform: "translate(0,0)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4C50",
    transform: "translate(0,0)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484D4C",
    transform: "translate(0,0)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5354",
    transform: "translate(0,0)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464B50",
    transform: "translate(0,0)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525659",
    transform: "translate(0,0)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#565958",
    transform: "translate(0,0)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4E50",
    transform: "translate(0,0)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#535657",
    transform: "translate(0,0)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#535758",
    transform: "translate(0,0)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#53585B",
    transform: "translate(0,0)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484A4E",
    transform: "translate(0,0)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505657",
    transform: "translate(0,0)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E4D",
    transform: "translate(0,0)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5255",
    transform: "translate(0,0)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#45494C",
    transform: "translate(0,0)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#555A59",
    transform: "translate(0,0)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43484B",
    transform: "translate(0,0)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5253",
    transform: "translate(0,0)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#545858",
    transform: "translate(0,0)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5155",
    transform: "translate(0,0)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505252",
    transform: "translate(0,0)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454B4B",
    transform: "translate(0,0)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515355",
    transform: "translate(0,0)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444949",
    transform: "translate(0,0)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42484A",
    transform: "translate(0,0)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5456",
    transform: "translate(0,0)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434748",
    transform: "translate(0,0)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515555",
    transform: "translate(0,0)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414646",
    transform: "translate(0,0)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515456",
    transform: "translate(0,0)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D51",
    transform: "translate(0,0)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525457",
    transform: "translate(0,0)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5357",
    transform: "translate(0,0)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4E4F",
    transform: "translate(0,0)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5454",
    transform: "translate(0,0)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5052",
    transform: "translate(0,0)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5454",
    transform: "translate(0,0)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474B4D",
    transform: "translate(0,0)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434B4B",
    transform: "translate(0,0)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404747",
    transform: "translate(0,0)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515556",
    transform: "translate(0,0)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#46484A",
    transform: "translate(0,0)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515455",
    transform: "translate(0,0)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505655",
    transform: "translate(0,0)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515655",
    transform: "translate(0,0)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5354",
    transform: "translate(0,0)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#44464A",
    transform: "translate(0,0)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444A4C",
    transform: "translate(0,0)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5656",
    transform: "translate(0,0)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4A4A",
    transform: "translate(0,0)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F4647",
    transform: "translate(0,0)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#585E5B",
    transform: "translate(0,0)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505355",
    transform: "translate(0,0)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#595B5B",
    transform: "translate(0,0)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5A5B5C",
    transform: "translate(0,0)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5054",
    transform: "translate(0,0)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5555",
    transform: "translate(0,0)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515150",
    transform: "translate(0,0)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#555A5B",
    transform: "translate(0,0)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#565B5D",
    transform: "translate(0,0)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#535859",
    transform: "translate(0,0)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5A5E5D",
    transform: "translate(0,0)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404547",
    transform: "translate(0,0)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515456",
    transform: "translate(0,0)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5154",
    transform: "translate(0,0)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#575B5B",
    transform: "translate(0,0)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525957",
    transform: "translate(0,0)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5354",
    transform: "translate(0,0)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5354",
    transform: "translate(0,0)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#54585A",
    transform: "translate(0,0)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414747",
    transform: "translate(0,0)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#575C5C",
    transform: "translate(0,0)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#555C5C",
    transform: "translate(0,0)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525956",
    transform: "translate(0,0)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5454",
    transform: "translate(0,0)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5656",
    transform: "translate(0,0)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525858",
    transform: "translate(0,0)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#54595A",
    transform: "translate(0,0)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5153",
    transform: "translate(0,0)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5455",
    transform: "translate(0,0)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D4D",
    transform: "translate(0,0)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484A4D",
    transform: "translate(0,0)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#48504E",
    transform: "translate(0,0)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5050",
    transform: "translate(0,0)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505657",
    transform: "translate(0,0)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5255",
    transform: "translate(0,0)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5253",
    transform: "translate(0,0)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5659",
    transform: "translate(0,0)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5357",
    transform: "translate(0,0)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505858",
    transform: "translate(0,0)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5252",
    transform: "translate(0,0)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5357",
    transform: "translate(0,0)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454C4D",
    transform: "translate(0,0)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505156",
    transform: "translate(0,0)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5354",
    transform: "translate(0,0)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5155",
    transform: "translate(0,0)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4F52",
    transform: "translate(0,0)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505658",
    transform: "translate(0,0)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4E4E",
    transform: "translate(0,0)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4E50",
    transform: "translate(0,0)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4F51",
    transform: "translate(0,0)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5553",
    transform: "translate(0,0)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5656",
    transform: "translate(0,0)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5657",
    transform: "translate(0,0)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495051",
    transform: "translate(0,0)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4C4C",
    transform: "translate(0,0)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4C4C",
    transform: "translate(0,0)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5153",
    transform: "translate(0,0)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5155",
    transform: "translate(0,0)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5356",
    transform: "translate(0,0)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505658",
    transform: "translate(0,0)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4F51",
    transform: "translate(0,0)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4F51",
    transform: "translate(0,0)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5151",
    transform: "translate(0,0)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#45494D",
    transform: "translate(0,0)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#56595B",
    transform: "translate(0,0)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4B4B",
    transform: "translate(0,0)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#504F51",
    transform: "translate(0,0)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#535757",
    transform: "translate(0,0)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5355",
    transform: "translate(0,0)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5556",
    transform: "translate(0,0)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5050",
    transform: "translate(0,0)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495052",
    transform: "translate(0,0)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#565D5E",
    transform: "translate(0,0)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#595C5D",
    transform: "translate(0,0)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#575B5D",
    transform: "translate(0,0)"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5C5D5C",
    transform: "translate(0,0)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5153",
    transform: "translate(0,0)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5053",
    transform: "translate(0,0)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#585B5D",
    transform: "translate(0,0)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5A5C5E",
    transform: "translate(0,0)"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5050",
    transform: "translate(0,0)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5B5D5D",
    transform: "translate(0,0)"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474E4F",
    transform: "translate(0,0)"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5655",
    transform: "translate(0,0)"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#5B5A5B",
    transform: "translate(0,0)"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5555",
    transform: "translate(0,0)"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474E4F",
    transform: "translate(0,0)"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D575A",
    transform: "translate(0,0)"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#595D5D",
    transform: "translate(0,0)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#56595C",
    transform: "translate(0,0)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5153",
    transform: "translate(0,0)"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5153",
    transform: "translate(0,0)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4E4E",
    transform: "translate(0,0)"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5255",
    transform: "translate(0,0)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4F53",
    transform: "translate(0,0)"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5253",
    transform: "translate(0,0)"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5050",
    transform: "translate(0,0)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5150",
    transform: "translate(0,0)"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484D50",
    transform: "translate(0,0)"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#545859",
    transform: "translate(0,0)"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515556",
    transform: "translate(0,0)"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5054",
    transform: "translate(0,0)"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5050",
    transform: "translate(0,0)"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474C52",
    transform: "translate(0,0)"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4D52",
    transform: "translate(0,0)"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5554",
    transform: "translate(0,0)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4F50",
    transform: "translate(0,0)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485252",
    transform: "translate(0,0)"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5153",
    transform: "translate(0,0)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5253",
    transform: "translate(0,0)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5252",
    transform: "translate(0,0)"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5153",
    transform: "translate(0,0)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5250",
    transform: "translate(0,0)"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5554",
    transform: "translate(0,0)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515854",
    transform: "translate(0,0)"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E51",
    transform: "translate(0,0)"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5354",
    transform: "translate(0,0)"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5453",
    transform: "translate(0,0)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5051",
    transform: "translate(0,0)"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#575A58",
    transform: "translate(0,0)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F50",
    transform: "translate(0,0)"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F51",
    transform: "translate(0,0)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E4F",
    transform: "translate(0,0)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4E53",
    transform: "translate(0,0)"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F51",
    transform: "translate(0,0)"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4F4C",
    transform: "translate(0,0)"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5051",
    transform: "translate(0,0)"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4E51",
    transform: "translate(0,0)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4E51",
    transform: "translate(0,0)"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5152",
    transform: "translate(0,0)"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#48514F",
    transform: "translate(0,0)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F51",
    transform: "translate(0,0)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5454",
    transform: "translate(0,0)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5053",
    transform: "translate(0,0)"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5251",
    transform: "translate(0,0)"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F50",
    transform: "translate(0,0)"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4D50",
    transform: "translate(0,0)"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5153",
    transform: "translate(0,0)"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505354",
    transform: "translate(0,0)"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5152",
    transform: "translate(0,0)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F52",
    transform: "translate(0,0)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F51",
    transform: "translate(0,0)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5154",
    transform: "translate(0,0)"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4E4F",
    transform: "translate(0,0)"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484C4F",
    transform: "translate(0,0)"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F4E",
    transform: "translate(0,0)"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4E4D",
    transform: "translate(0,0)"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474F4D",
    transform: "translate(0,0)"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F51",
    transform: "translate(0,0)"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E4F",
    transform: "translate(0,0)"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474C4F",
    transform: "translate(0,0)"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A504F",
    transform: "translate(0,0)"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444D4E",
    transform: "translate(0,0)"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E51",
    transform: "translate(0,0)"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5051",
    transform: "translate(0,0)"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E50",
    transform: "translate(0,0)"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474A50",
    transform: "translate(0,0)"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C4F",
    transform: "translate(0,0)"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F53",
    transform: "translate(0,0)"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4E51",
    transform: "translate(0,0)"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4C4D",
    transform: "translate(0,0)"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5355",
    transform: "translate(0,0)"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#45474C",
    transform: "translate(0,0)"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4E4E",
    transform: "translate(0,0)"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5052",
    transform: "translate(0,0)"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5254",
    transform: "translate(0,0)"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494D4E",
    transform: "translate(0,0)"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5051",
    transform: "translate(0,0)"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495051",
    transform: "translate(0,0)"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464D4F",
    transform: "translate(0,0)"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464D4F",
    transform: "translate(0,0)"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4F50",
    transform: "translate(0,0)"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E51",
    transform: "translate(0,0)"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464E50",
    transform: "translate(0,0)"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5255",
    transform: "translate(0,0)"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4B4A",
    transform: "translate(0,0)"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D4E",
    transform: "translate(0,0)"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#46494D",
    transform: "translate(0,0)"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474E4F",
    transform: "translate(0,0)"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5050",
    transform: "translate(0,0)"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4C4F",
    transform: "translate(0,0)"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444B4A",
    transform: "translate(0,0)"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4E54",
    transform: "translate(0,0)"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5251",
    transform: "translate(0,0)"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485050",
    transform: "translate(0,0)"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454D4F",
    transform: "translate(0,0)"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F51",
    transform: "translate(0,0)"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F4F",
    transform: "translate(0,0)"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454E4D",
    transform: "translate(0,0)"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E4E",
    transform: "translate(0,0)"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494D4D",
    transform: "translate(0,0)"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F50",
    transform: "translate(0,0)"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495151",
    transform: "translate(0,0)"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D4E",
    transform: "translate(0,0)"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4E50",
    transform: "translate(0,0)"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4F4F",
    transform: "translate(0,0)"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434A4F",
    transform: "translate(0,0)"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4D50",
    transform: "translate(0,0)"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#465150",
    transform: "translate(0,0)"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484C50",
    transform: "translate(0,0)"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484D4F",
    transform: "translate(0,0)"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464A4D",
    transform: "translate(0,0)"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474F4F",
    transform: "translate(0,0)"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5150",
    transform: "translate(0,0)"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444C51",
    transform: "translate(0,0)"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464B4D",
    transform: "translate(0,0)"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5252",
    transform: "translate(0,0)"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5254",
    transform: "translate(0,0)"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E50",
    transform: "translate(0,0)"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5050",
    transform: "translate(0,0)"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5052",
    transform: "translate(0,0)"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495250",
    transform: "translate(0,0)"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484D4E",
    transform: "translate(0,0)"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484B4D",
    transform: "translate(0,0)"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4F4E",
    transform: "translate(0,0)"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C4C",
    transform: "translate(0,0)"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454F52",
    transform: "translate(0,0)"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#475051",
    transform: "translate(0,0)"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F52",
    transform: "translate(0,0)"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404447",
    transform: "translate(0,0)"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F4A48",
    transform: "translate(0,0)"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454C4E",
    transform: "translate(0,0)"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4D52",
    transform: "translate(0,0)"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464A4E",
    transform: "translate(0,0)"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5151",
    transform: "translate(0,0)"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434A4C",
    transform: "translate(0,0)"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474E51",
    transform: "translate(0,0)"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E51",
    transform: "translate(0,0)"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C4E",
    transform: "translate(0,0)"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444B51",
    transform: "translate(0,0)"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5052",
    transform: "translate(0,0)"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474C4E",
    transform: "translate(0,0)"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474F52",
    transform: "translate(0,0)"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464F4F",
    transform: "translate(0,0)"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485151",
    transform: "translate(0,0)"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5253",
    transform: "translate(0,0)"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434B4B",
    transform: "translate(0,0)"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474C4F",
    transform: "translate(0,0)"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474C4D",
    transform: "translate(0,0)"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5251",
    transform: "translate(0,0)"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E4E",
    transform: "translate(0,0)"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E4E",
    transform: "translate(0,0)"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404B50",
    transform: "translate(0,0)"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4E53",
    transform: "translate(0,0)"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41434A",
    transform: "translate(0,0)"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525759",
    transform: "translate(0,0)"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C50",
    transform: "translate(0,0)"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#475151",
    transform: "translate(0,0)"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F50",
    transform: "translate(0,0)"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464F4F",
    transform: "translate(0,0)"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D4649",
    transform: "translate(0,0)"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424C4E",
    transform: "translate(0,0)"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C52",
    transform: "translate(0,0)"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4F54",
    transform: "translate(0,0)"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#44494B",
    transform: "translate(0,0)"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474B4D",
    transform: "translate(0,0)"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5252",
    transform: "translate(0,0)"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E52",
    transform: "translate(0,0)"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484D50",
    transform: "translate(0,0)"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#49504E",
    transform: "translate(0,0)"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#49504F",
    transform: "translate(0,0)"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434C4D",
    transform: "translate(0,0)"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474E4E",
    transform: "translate(0,0)"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404849",
    transform: "translate(0,0)"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495354",
    transform: "translate(0,0)"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5456",
    transform: "translate(0,0)"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F50",
    transform: "translate(0,0)"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5154",
    transform: "translate(0,0)"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4D50",
    transform: "translate(0,0)"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42484C",
    transform: "translate(0,0)"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5357",
    transform: "translate(0,0)"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F52",
    transform: "translate(0,0)"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5252",
    transform: "translate(0,0)"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5052",
    transform: "translate(0,0)"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4F4E",
    transform: "translate(0,0)"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5254",
    transform: "translate(0,0)"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5051",
    transform: "translate(0,0)"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525352",
    transform: "translate(0,0)"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#44484D",
    transform: "translate(0,0)"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434A4C",
    transform: "translate(0,0)"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D52",
    transform: "translate(0,0)"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464D4F",
    transform: "translate(0,0)"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505555",
    transform: "translate(0,0)"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D4D",
    transform: "translate(0,0)"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505756",
    transform: "translate(0,0)"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4E53",
    transform: "translate(0,0)"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454A4F",
    transform: "translate(0,0)"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414B4A",
    transform: "translate(0,0)"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#555B5C",
    transform: "translate(0,0)"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474A4C",
    transform: "translate(0,0)"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454E50",
    transform: "translate(0,0)"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464D50",
    transform: "translate(0,0)"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454E4E",
    transform: "translate(0,0)"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41474D",
    transform: "translate(0,0)"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5154",
    transform: "translate(0,0)"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4F51",
    transform: "translate(0,0)"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F4F",
    transform: "translate(0,0)"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454E4F",
    transform: "translate(0,0)"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464D4C",
    transform: "translate(0,0)"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E50",
    transform: "translate(0,0)"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404345",
    transform: "translate(0,0)"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4F51",
    transform: "translate(0,0)"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424E50",
    transform: "translate(0,0)"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444B4E",
    transform: "translate(0,0)"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5153",
    transform: "translate(0,0)"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444A4D",
    transform: "translate(0,0)"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515454",
    transform: "translate(0,0)"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5456",
    transform: "translate(0,0)"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#44494C",
    transform: "translate(0,0)"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434A50",
    transform: "translate(0,0)"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5354",
    transform: "translate(0,0)"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F52",
    transform: "translate(0,0)"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5557",
    transform: "translate(0,0)"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5557",
    transform: "translate(0,0)"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505354",
    transform: "translate(0,0)"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5255",
    transform: "translate(0,0)"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495152",
    transform: "translate(0,0)"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474A4C",
    transform: "translate(0,0)"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4E50",
    transform: "translate(0,0)"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4E51",
    transform: "translate(0,0)"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454C4D",
    transform: "translate(0,0)"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D50",
    transform: "translate(0,0)"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5255",
    transform: "translate(0,0)"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454A4C",
    transform: "translate(0,0)"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454544",
    transform: "translate(0,0)"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5355",
    transform: "translate(0,0)"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495051",
    transform: "translate(0,0)"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454B4B",
    transform: "translate(0,0)"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464F4F",
    transform: "translate(0,0)"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414849",
    transform: "translate(0,0)"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444E4F",
    transform: "translate(0,0)"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E52",
    transform: "translate(0,0)"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485053",
    transform: "translate(0,0)"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484C4C",
    transform: "translate(0,0)"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424648",
    transform: "translate(0,0)"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464D4E",
    transform: "translate(0,0)"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474E4E",
    transform: "translate(0,0)"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4A49",
    transform: "translate(0,0)"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454A4B",
    transform: "translate(0,0)"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F52",
    transform: "translate(0,0)"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414747",
    transform: "translate(0,0)"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F51",
    transform: "translate(0,0)"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454D4E",
    transform: "translate(0,0)"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474E50",
    transform: "translate(0,0)"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444A4A",
    transform: "translate(0,0)"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454B4D",
    transform: "translate(0,0)"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414A4B",
    transform: "translate(0,0)"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434B4B",
    transform: "translate(0,0)"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484D4E",
    transform: "translate(0,0)"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474C4F",
    transform: "translate(0,0)"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464D4E",
    transform: "translate(0,0)"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464A4E",
    transform: "translate(0,0)"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424A4B",
    transform: "translate(0,0)"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C4D",
    transform: "translate(0,0)"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#475051",
    transform: "translate(0,0)"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454D4F",
    transform: "translate(0,0)"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D4E",
    transform: "translate(0,0)"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5451",
    transform: "translate(0,0)"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E4F",
    transform: "translate(0,0)"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454C4E",
    transform: "translate(0,0)"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42484D",
    transform: "translate(0,0)"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F4B",
    transform: "translate(0,0)"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454D4D",
    transform: "translate(0,0)"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444B4E",
    transform: "translate(0,0)"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5351",
    transform: "translate(0,0)"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464950",
    transform: "translate(0,0)"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4D4F",
    transform: "translate(0,0)"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F4F",
    transform: "translate(0,0)"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414546",
    transform: "translate(0,0)"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4F4F",
    transform: "translate(0,0)"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4B4B",
    transform: "translate(0,0)"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5050",
    transform: "translate(0,0)"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5050",
    transform: "translate(0,0)"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414947",
    transform: "translate(0,0)"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474F4D",
    transform: "translate(0,0)"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D51",
    transform: "translate(0,0)"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5053",
    transform: "translate(0,0)"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5152",
    transform: "translate(0,0)"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F51",
    transform: "translate(0,0)"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#475050",
    transform: "translate(0,0)"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505455",
    transform: "translate(0,0)"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4F50",
    transform: "translate(0,0)"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#475050",
    transform: "translate(0,0)"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444B53",
    transform: "translate(0,0)"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#535658",
    transform: "translate(0,0)"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5352",
    transform: "translate(0,0)"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5257",
    transform: "translate(0,0)"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A514F",
    transform: "translate(0,0)"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5150",
    transform: "translate(0,0)"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494D50",
    transform: "translate(0,0)"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434C4D",
    transform: "translate(0,0)"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#394347",
    transform: "translate(0,0)"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5556",
    transform: "translate(0,0)"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485053",
    transform: "translate(0,0)"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515656",
    transform: "translate(0,0)"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464D4F",
    transform: "translate(0,0)"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A504F",
    transform: "translate(0,0)"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474E51",
    transform: "translate(0,0)"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484B4F",
    transform: "translate(0,0)"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505455",
    transform: "translate(0,0)"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5154",
    transform: "translate(0,0)"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444E50",
    transform: "translate(0,0)"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5457",
    transform: "translate(0,0)"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414845",
    transform: "translate(0,0)"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4F51",
    transform: "translate(0,0)"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E53",
    transform: "translate(0,0)"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5257",
    transform: "translate(0,0)"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5356",
    transform: "translate(0,0)"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5156",
    transform: "translate(0,0)"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505656",
    transform: "translate(0,0)"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5051",
    transform: "translate(0,0)"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495253",
    transform: "translate(0,0)"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5356",
    transform: "translate(0,0)"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5055",
    transform: "translate(0,0)"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#475052",
    transform: "translate(0,0)"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5253",
    transform: "translate(0,0)"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E51",
    transform: "translate(0,0)"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474C4E",
    transform: "translate(0,0)"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D50",
    transform: "translate(0,0)"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5354",
    transform: "translate(0,0)"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4D4D",
    transform: "translate(0,0)"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424C4E",
    transform: "translate(0,0)"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454C4C",
    transform: "translate(0,0)"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444B4C",
    transform: "translate(0,0)"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494D4D",
    transform: "translate(0,0)"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4D4D",
    transform: "translate(0,0)"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444B4C",
    transform: "translate(0,0)"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434B4E",
    transform: "translate(0,0)"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464D4F",
    transform: "translate(0,0)"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454B4D",
    transform: "translate(0,0)"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444C4A",
    transform: "translate(0,0)"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444E50",
    transform: "translate(0,0)"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E51",
    transform: "translate(0,0)"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#465154",
    transform: "translate(0,0)"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434D4E",
    transform: "translate(0,0)"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474C4E",
    transform: "translate(0,0)"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5355",
    transform: "translate(0,0)"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5254",
    transform: "translate(0,0)"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5451",
    transform: "translate(0,0)"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505255",
    transform: "translate(0,0)"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5355",
    transform: "translate(0,0)"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5253",
    transform: "translate(0,0)"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42484D",
    transform: "translate(0,0)"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5556",
    transform: "translate(0,0)"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5656",
    transform: "translate(0,0)"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495254",
    transform: "translate(0,0)"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505859",
    transform: "translate(0,0)"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5555",
    transform: "translate(0,0)"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5256",
    transform: "translate(0,0)"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F54",
    transform: "translate(0,0)"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#47504F",
    transform: "translate(0,0)"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464B51",
    transform: "translate(0,0)"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#49504E",
    transform: "translate(0,0)"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464F50",
    transform: "translate(0,0)"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#44494C",
    transform: "translate(0,0)"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5555",
    transform: "translate(0,0)"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525858",
    transform: "translate(0,0)"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4F51",
    transform: "translate(0,0)"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5050",
    transform: "translate(0,0)"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5454",
    transform: "translate(0,0)"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505758",
    transform: "translate(0,0)"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E4F",
    transform: "translate(0,0)"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5457",
    transform: "translate(0,0)"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495556",
    transform: "translate(0,0)"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525959",
    transform: "translate(0,0)"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485050",
    transform: "translate(0,0)"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43494C",
    transform: "translate(0,0)"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F595B",
    transform: "translate(0,0)"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#52595B",
    transform: "translate(0,0)"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5356",
    transform: "translate(0,0)"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5155",
    transform: "translate(0,0)"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5255",
    transform: "translate(0,0)"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#53595B",
    transform: "translate(0,0)"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5358",
    transform: "translate(0,0)"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5253",
    transform: "translate(0,0)"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525659",
    transform: "translate(0,0)"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#455050",
    transform: "translate(0,0)"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5457",
    transform: "translate(0,0)"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495254",
    transform: "translate(0,0)"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485155",
    transform: "translate(0,0)"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42494B",
    transform: "translate(0,0)"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414A48",
    transform: "translate(0,0)"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5356",
    transform: "translate(0,0)"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5558",
    transform: "translate(0,0)"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#53585A",
    transform: "translate(0,0)"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464B4D",
    transform: "translate(0,0)"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#535B58",
    transform: "translate(0,0)"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#545759",
    transform: "translate(0,0)"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5554",
    transform: "translate(0,0)"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5051",
    transform: "translate(0,0)"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5053",
    transform: "translate(0,0)"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5051",
    transform: "translate(0,0)"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F53",
    transform: "translate(0,0)"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5455",
    transform: "translate(0,0)"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43484B",
    transform: "translate(0,0)"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5556",
    transform: "translate(0,0)"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5052",
    transform: "translate(0,0)"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5558",
    transform: "translate(0,0)"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5253",
    transform: "translate(0,0)"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42474E",
    transform: "translate(0,0)"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414848",
    transform: "translate(0,0)"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B4446",
    transform: "translate(0,0)"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464E4F",
    transform: "translate(0,0)"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5354",
    transform: "translate(0,0)"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434B4F",
    transform: "translate(0,0)"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505A5A",
    transform: "translate(0,0)"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495053",
    transform: "translate(0,0)"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5152",
    transform: "translate(0,0)"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495152",
    transform: "translate(0,0)"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E4247",
    transform: "translate(0,0)"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5455",
    transform: "translate(0,0)"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485052",
    transform: "translate(0,0)"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474C50",
    transform: "translate(0,0)"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404948",
    transform: "translate(0,0)"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4D4D",
    transform: "translate(0,0)"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5152",
    transform: "translate(0,0)"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5957",
    transform: "translate(0,0)"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C4E",
    transform: "translate(0,0)"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41494B",
    transform: "translate(0,0)"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#545756",
    transform: "translate(0,0)"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41484A",
    transform: "translate(0,0)"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E4648",
    transform: "translate(0,0)"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474C4E",
    transform: "translate(0,0)"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5257",
    transform: "translate(0,0)"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414A4E",
    transform: "translate(0,0)"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494D52",
    transform: "translate(0,0)"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5253",
    transform: "translate(0,0)"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444B4D",
    transform: "translate(0,0)"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464E51",
    transform: "translate(0,0)"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5256",
    transform: "translate(0,0)"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5254",
    transform: "translate(0,0)"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444E4F",
    transform: "translate(0,0)"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424F4F",
    transform: "translate(0,0)"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474B4C",
    transform: "translate(0,0)"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F4849",
    transform: "translate(0,0)"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414A4E",
    transform: "translate(0,0)"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434E52",
    transform: "translate(0,0)"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E50",
    transform: "translate(0,0)"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495155",
    transform: "translate(0,0)"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5355",
    transform: "translate(0,0)"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4F51",
    transform: "translate(0,0)"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484B51",
    transform: "translate(0,0)"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5053",
    transform: "translate(0,0)"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5153",
    transform: "translate(0,0)"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414A4A",
    transform: "translate(0,0)"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42484D",
    transform: "translate(0,0)"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434B4E",
    transform: "translate(0,0)"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40474A",
    transform: "translate(0,0)"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454D4F",
    transform: "translate(0,0)"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5154",
    transform: "translate(0,0)"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454C4F",
    transform: "translate(0,0)"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424B4B",
    transform: "translate(0,0)"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424A4B",
    transform: "translate(0,0)"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5356",
    transform: "translate(0,0)"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5152",
    transform: "translate(0,0)"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414A4B",
    transform: "translate(0,0)"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434C4F",
    transform: "translate(0,0)"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42484B",
    transform: "translate(0,0)"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404547",
    transform: "translate(0,0)"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5353",
    transform: "translate(0,0)"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D51",
    transform: "translate(0,0)"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434B4D",
    transform: "translate(0,0)"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485053",
    transform: "translate(0,0)"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454B4F",
    transform: "translate(0,0)"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404949",
    transform: "translate(0,0)"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485153",
    transform: "translate(0,0)"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434A4B",
    transform: "translate(0,0)"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43494C",
    transform: "translate(0,0)"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42494A",
    transform: "translate(0,0)"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464D52",
    transform: "translate(0,0)"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444C4E",
    transform: "translate(0,0)"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434C4D",
    transform: "translate(0,0)"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43494C",
    transform: "translate(0,0)"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42484C",
    transform: "translate(0,0)"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E4A4A",
    transform: "translate(0,0)"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414B4C",
    transform: "translate(0,0)"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414B4E",
    transform: "translate(0,0)"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40464C",
    transform: "translate(0,0)"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F474A",
    transform: "translate(0,0)"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#44484C",
    transform: "translate(0,0)"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42494B",
    transform: "translate(0,0)"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F464C",
    transform: "translate(0,0)"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495456",
    transform: "translate(0,0)"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434C4D",
    transform: "translate(0,0)"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424B4D",
    transform: "translate(0,0)"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42494A",
    transform: "translate(0,0)"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454C4E",
    transform: "translate(0,0)"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F444D",
    transform: "translate(0,0)"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444A4D",
    transform: "translate(0,0)"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373A3F",
    transform: "translate(0,0)"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414747",
    transform: "translate(0,0)"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5054",
    transform: "translate(0,0)"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494D52",
    transform: "translate(0,0)"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454E52",
    transform: "translate(0,0)"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F50",
    transform: "translate(0,0)"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C4345",
    transform: "translate(0,0)"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C4F",
    transform: "translate(0,0)"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F50",
    transform: "translate(0,0)"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494D51",
    transform: "translate(0,0)"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C4548",
    transform: "translate(0,0)"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414647",
    transform: "translate(0,0)"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D4F",
    transform: "translate(0,0)"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#475050",
    transform: "translate(0,0)"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495252",
    transform: "translate(0,0)"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434E4E",
    transform: "translate(0,0)"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F494D",
    transform: "translate(0,0)"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#475050",
    transform: "translate(0,0)"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464D4E",
    transform: "translate(0,0)"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454E52",
    transform: "translate(0,0)"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434C50",
    transform: "translate(0,0)"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434A4C",
    transform: "translate(0,0)"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414648",
    transform: "translate(0,0)"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414749",
    transform: "translate(0,0)"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C4E",
    transform: "translate(0,0)"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434B4E",
    transform: "translate(0,0)"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B494A",
    transform: "translate(0,0)"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F4648",
    transform: "translate(0,0)"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485153",
    transform: "translate(0,0)"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495254",
    transform: "translate(0,0)"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5256",
    transform: "translate(0,0)"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424A4A",
    transform: "translate(0,0)"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D51",
    transform: "translate(0,0)"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42474A",
    transform: "translate(0,0)"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4F52",
    transform: "translate(0,0)"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495053",
    transform: "translate(0,0)"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5354",
    transform: "translate(0,0)"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424848",
    transform: "translate(0,0)"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454B4D",
    transform: "translate(0,0)"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42474B",
    transform: "translate(0,0)"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434A4C",
    transform: "translate(0,0)"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495254",
    transform: "translate(0,0)"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5252",
    transform: "translate(0,0)"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434749",
    transform: "translate(0,0)"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5357",
    transform: "translate(0,0)"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E52",
    transform: "translate(0,0)"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444E4F",
    transform: "translate(0,0)"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424B4C",
    transform: "translate(0,0)"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F4447",
    transform: "translate(0,0)"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42494E",
    transform: "translate(0,0)"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D4848",
    transform: "translate(0,0)"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414C4D",
    transform: "translate(0,0)"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444A4E",
    transform: "translate(0,0)"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474A4D",
    transform: "translate(0,0)"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484C50",
    transform: "translate(0,0)"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434C4F",
    transform: "translate(0,0)"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40484C",
    transform: "translate(0,0)"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404A4B",
    transform: "translate(0,0)"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434A4C",
    transform: "translate(0,0)"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484D52",
    transform: "translate(0,0)"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464F52",
    transform: "translate(0,0)"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495050",
    transform: "translate(0,0)"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434C4E",
    transform: "translate(0,0)"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464A50",
    transform: "translate(0,0)"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474E50",
    transform: "translate(0,0)"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404A4B",
    transform: "translate(0,0)"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F50",
    transform: "translate(0,0)"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495051",
    transform: "translate(0,0)"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495155",
    transform: "translate(0,0)"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4E54",
    transform: "translate(0,0)"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F53",
    transform: "translate(0,0)"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F4548",
    transform: "translate(0,0)"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424B4E",
    transform: "translate(0,0)"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474F52",
    transform: "translate(0,0)"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495052",
    transform: "translate(0,0)"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D50",
    transform: "translate(0,0)"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5152",
    transform: "translate(0,0)"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41474A",
    transform: "translate(0,0)"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41484F",
    transform: "translate(0,0)"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454D4E",
    transform: "translate(0,0)"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454B4F",
    transform: "translate(0,0)"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43484B",
    transform: "translate(0,0)"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434847",
    transform: "translate(0,0)"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E4B4A",
    transform: "translate(0,0)"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404A4A",
    transform: "translate(0,0)"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41474B",
    transform: "translate(0,0)"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444A4C",
    transform: "translate(0,0)"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42464C",
    transform: "translate(0,0)"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E51",
    transform: "translate(0,0)"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474E4F",
    transform: "translate(0,0)"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424A4E",
    transform: "translate(0,0)"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41494B",
    transform: "translate(0,0)"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434D4A",
    transform: "translate(0,0)"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#455253",
    transform: "translate(0,0)"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4D52",
    transform: "translate(0,0)"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484D4F",
    transform: "translate(0,0)"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C49",
    transform: "translate(0,0)"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444A4D",
    transform: "translate(0,0)"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5253",
    transform: "translate(0,0)"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4E50",
    transform: "translate(0,0)"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5255",
    transform: "translate(0,0)"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#49504F",
    transform: "translate(0,0)"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414B4C",
    transform: "translate(0,0)"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424A4A",
    transform: "translate(0,0)"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F4549",
    transform: "translate(0,0)"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5354",
    transform: "translate(0,0)"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5556",
    transform: "translate(0,0)"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485053",
    transform: "translate(0,0)"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F4647",
    transform: "translate(0,0)"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5454",
    transform: "translate(0,0)"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5355",
    transform: "translate(0,0)"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444C4E",
    transform: "translate(0,0)"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5257",
    transform: "translate(0,0)"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404B4B",
    transform: "translate(0,0)"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5153",
    transform: "translate(0,0)"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40474B",
    transform: "translate(0,0)"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D4B",
    transform: "translate(0,0)"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4E51",
    transform: "translate(0,0)"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#394346",
    transform: "translate(0,0)"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414749",
    transform: "translate(0,0)"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464D50",
    transform: "translate(0,0)"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43494E",
    transform: "translate(0,0)"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424A4F",
    transform: "translate(0,0)"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5252",
    transform: "translate(0,0)"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484D52",
    transform: "translate(0,0)"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5354",
    transform: "translate(0,0)"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434A4C",
    transform: "translate(0,0)"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D4E",
    transform: "translate(0,0)"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C4346",
    transform: "translate(0,0)"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5252",
    transform: "translate(0,0)"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5556",
    transform: "translate(0,0)"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5355",
    transform: "translate(0,0)"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464B4C",
    transform: "translate(0,0)"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D51",
    transform: "translate(0,0)"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5455",
    transform: "translate(0,0)"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505657",
    transform: "translate(0,0)"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#44494E",
    transform: "translate(0,0)"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40494A",
    transform: "translate(0,0)"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40484C",
    transform: "translate(0,0)"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485051",
    transform: "translate(0,0)"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F4747",
    transform: "translate(0,0)"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474C50",
    transform: "translate(0,0)"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5455",
    transform: "translate(0,0)"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5653",
    transform: "translate(0,0)"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5356",
    transform: "translate(0,0)"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#44494C",
    transform: "translate(0,0)"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424547",
    transform: "translate(0,0)"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5353",
    transform: "translate(0,0)"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404849",
    transform: "translate(0,0)"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5153",
    transform: "translate(0,0)"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474E51",
    transform: "translate(0,0)"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5455",
    transform: "translate(0,0)"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444A4D",
    transform: "translate(0,0)"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464E4F",
    transform: "translate(0,0)"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#475052",
    transform: "translate(0,0)"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414848",
    transform: "translate(0,0)"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5154",
    transform: "translate(0,0)"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4F53",
    transform: "translate(0,0)"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434A48",
    transform: "translate(0,0)"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5355",
    transform: "translate(0,0)"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414548",
    transform: "translate(0,0)"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F4F",
    transform: "translate(0,0)"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42464A",
    transform: "translate(0,0)"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485253",
    transform: "translate(0,0)"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42494D",
    transform: "translate(0,0)"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404547",
    transform: "translate(0,0)"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5656",
    transform: "translate(0,0)"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5257",
    transform: "translate(0,0)"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485153",
    transform: "translate(0,0)"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454F4F",
    transform: "translate(0,0)"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434D4E",
    transform: "translate(0,0)"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A4343",
    transform: "translate(0,0)"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E4848",
    transform: "translate(0,0)"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5756",
    transform: "translate(0,0)"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5255",
    transform: "translate(0,0)"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5556",
    transform: "translate(0,0)"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41464B",
    transform: "translate(0,0)"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D50",
    transform: "translate(0,0)"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40494A",
    transform: "translate(0,0)"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424C4F",
    transform: "translate(0,0)"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F52",
    transform: "translate(0,0)"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5353",
    transform: "translate(0,0)"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464A4F",
    transform: "translate(0,0)"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495253",
    transform: "translate(0,0)"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F51",
    transform: "translate(0,0)"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43494B",
    transform: "translate(0,0)"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434B4D",
    transform: "translate(0,0)"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F52",
    transform: "translate(0,0)"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404947",
    transform: "translate(0,0)"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E4D",
    transform: "translate(0,0)"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454B4E",
    transform: "translate(0,0)"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414849",
    transform: "translate(0,0)"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414A4B",
    transform: "translate(0,0)"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424D4C",
    transform: "translate(0,0)"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434B4C",
    transform: "translate(0,0)"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5154",
    transform: "translate(0,0)"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40484E",
    transform: "translate(0,0)"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F484C",
    transform: "translate(0,0)"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444B4E",
    transform: "translate(0,0)"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464F50",
    transform: "translate(0,0)"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42494D",
    transform: "translate(0,0)"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505255",
    transform: "translate(0,0)"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40494A",
    transform: "translate(0,0)"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444C4E",
    transform: "translate(0,0)"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5051",
    transform: "translate(0,0)"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424A4D",
    transform: "translate(0,0)"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C4F",
    transform: "translate(0,0)"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454E4F",
    transform: "translate(0,0)"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485052",
    transform: "translate(0,0)"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414649",
    transform: "translate(0,0)"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5456",
    transform: "translate(0,0)"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5354",
    transform: "translate(0,0)"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5355",
    transform: "translate(0,0)"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454F50",
    transform: "translate(0,0)"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41484B",
    transform: "translate(0,0)"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404849",
    transform: "translate(0,0)"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454D4F",
    transform: "translate(0,0)"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E51",
    transform: "translate(0,0)"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434F51",
    transform: "translate(0,0)"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444E50",
    transform: "translate(0,0)"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444D4C",
    transform: "translate(0,0)"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41474B",
    transform: "translate(0,0)"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434B4E",
    transform: "translate(0,0)"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5154",
    transform: "translate(0,0)"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43464B",
    transform: "translate(0,0)"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404749",
    transform: "translate(0,0)"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373D44",
    transform: "translate(0,0)"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#555958",
    transform: "translate(0,0)"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5254",
    transform: "translate(0,0)"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495153",
    transform: "translate(0,0)"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444E51",
    transform: "translate(0,0)"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#555C5A",
    transform: "translate(0,0)"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E52",
    transform: "translate(0,0)"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414A4C",
    transform: "translate(0,0)"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#56585A",
    transform: "translate(0,0)"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444B4E",
    transform: "translate(0,0)"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42494B",
    transform: "translate(0,0)"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484B4D",
    transform: "translate(0,0)"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464E4D",
    transform: "translate(0,0)"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474F52",
    transform: "translate(0,0)"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F4F",
    transform: "translate(0,0)"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E50",
    transform: "translate(0,0)"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5254",
    transform: "translate(0,0)"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E54",
    transform: "translate(0,0)"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464F54",
    transform: "translate(0,0)"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E484A",
    transform: "translate(0,0)"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484D50",
    transform: "translate(0,0)"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485050",
    transform: "translate(0,0)"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42494F",
    transform: "translate(0,0)"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F51",
    transform: "translate(0,0)"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C4447",
    transform: "translate(0,0)"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A4948",
    transform: "translate(0,0)"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454E4A",
    transform: "translate(0,0)"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495054",
    transform: "translate(0,0)"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494D51",
    transform: "translate(0,0)"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#475152",
    transform: "translate(0,0)"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#394447",
    transform: "translate(0,0)"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414547",
    transform: "translate(0,0)"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424B4E",
    transform: "translate(0,0)"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494D4F",
    transform: "translate(0,0)"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4E50",
    transform: "translate(0,0)"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43494B",
    transform: "translate(0,0)"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444C4E",
    transform: "translate(0,0)"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495155",
    transform: "translate(0,0)"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41494C",
    transform: "translate(0,0)"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42494E",
    transform: "translate(0,0)"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F4649",
    transform: "translate(0,0)"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C4E",
    transform: "translate(0,0)"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495151",
    transform: "translate(0,0)"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#465152",
    transform: "translate(0,0)"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454D4F",
    transform: "translate(0,0)"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E4448",
    transform: "translate(0,0)"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5455",
    transform: "translate(0,0)"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#53585B",
    transform: "translate(0,0)"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424C4F",
    transform: "translate(0,0)"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5254",
    transform: "translate(0,0)"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454A4E",
    transform: "translate(0,0)"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454B4D",
    transform: "translate(0,0)"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#465151",
    transform: "translate(0,0)"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5254",
    transform: "translate(0,0)"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#55595A",
    transform: "translate(0,0)"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5251",
    transform: "translate(0,0)"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434A4E",
    transform: "translate(0,0)"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C4348",
    transform: "translate(0,0)"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5655",
    transform: "translate(0,0)"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515859",
    transform: "translate(0,0)"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#535B59",
    transform: "translate(0,0)"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F53",
    transform: "translate(0,0)"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454E51",
    transform: "translate(0,0)"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464D4E",
    transform: "translate(0,0)"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454C4D",
    transform: "translate(0,0)"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E51",
    transform: "translate(0,0)"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444B4B",
    transform: "translate(0,0)"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B4444",
    transform: "translate(0,0)"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454B4D",
    transform: "translate(0,0)"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454A4B",
    transform: "translate(0,0)"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41454A",
    transform: "translate(0,0)"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495051",
    transform: "translate(0,0)"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485052",
    transform: "translate(0,0)"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485355",
    transform: "translate(0,0)"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A4146",
    transform: "translate(0,0)"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404849",
    transform: "translate(0,0)"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434F50",
    transform: "translate(0,0)"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444E50",
    transform: "translate(0,0)"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5555",
    transform: "translate(0,0)"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474C4E",
    transform: "translate(0,0)"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42494B",
    transform: "translate(0,0)"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5152",
    transform: "translate(0,0)"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F4649",
    transform: "translate(0,0)"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E54",
    transform: "translate(0,0)"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#50575C",
    transform: "translate(0,0)"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F4748",
    transform: "translate(0,0)"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424849",
    transform: "translate(0,0)"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#44494C",
    transform: "translate(0,0)"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444B4C",
    transform: "translate(0,0)"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5655",
    transform: "translate(0,0)"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4A50",
    transform: "translate(0,0)"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424649",
    transform: "translate(0,0)"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474E51",
    transform: "translate(0,0)"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5052",
    transform: "translate(0,0)"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5251",
    transform: "translate(0,0)"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4F53",
    transform: "translate(0,0)"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5253",
    transform: "translate(0,0)"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E50",
    transform: "translate(0,0)"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4F51",
    transform: "translate(0,0)"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5352",
    transform: "translate(0,0)"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474A4D",
    transform: "translate(0,0)"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4F4F",
    transform: "translate(0,0)"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C50",
    transform: "translate(0,0)"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5255",
    transform: "translate(0,0)"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A4146",
    transform: "translate(0,0)"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#48504F",
    transform: "translate(0,0)"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434A50",
    transform: "translate(0,0)"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5054",
    transform: "translate(0,0)"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42444D",
    transform: "translate(0,0)"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F4C4C",
    transform: "translate(0,0)"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515254",
    transform: "translate(0,0)"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D4E",
    transform: "translate(0,0)"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5557",
    transform: "translate(0,0)"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464D51",
    transform: "translate(0,0)"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464E4E",
    transform: "translate(0,0)"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#51585A",
    transform: "translate(0,0)"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434A4C",
    transform: "translate(0,0)"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525959",
    transform: "translate(0,0)"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515458",
    transform: "translate(0,0)"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464E4D",
    transform: "translate(0,0)"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505956",
    transform: "translate(0,0)"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#465051",
    transform: "translate(0,0)"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F4F",
    transform: "translate(0,0)"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B4447",
    transform: "translate(0,0)"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5052",
    transform: "translate(0,0)"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D4648",
    transform: "translate(0,0)"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E4648",
    transform: "translate(0,0)"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495254",
    transform: "translate(0,0)"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4E50",
    transform: "translate(0,0)"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464E50",
    transform: "translate(0,0)"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F4A4A",
    transform: "translate(0,0)"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485153",
    transform: "translate(0,0)"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474E51",
    transform: "translate(0,0)"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E4447",
    transform: "translate(0,0)"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5254",
    transform: "translate(0,0)"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E54",
    transform: "translate(0,0)"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414848",
    transform: "translate(0,0)"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4C52",
    transform: "translate(0,0)"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454B4E",
    transform: "translate(0,0)"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4D4E",
    transform: "translate(0,0)"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5150",
    transform: "translate(0,0)"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5151",
    transform: "translate(0,0)"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#565B5B",
    transform: "translate(0,0)"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#535A5A",
    transform: "translate(0,0)"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5457",
    transform: "translate(0,0)"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525959",
    transform: "translate(0,0)"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464D4E",
    transform: "translate(0,0)"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#394142",
    transform: "translate(0,0)"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4F56",
    transform: "translate(0,0)"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5351",
    transform: "translate(0,0)"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4F50",
    transform: "translate(0,0)"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454B4F",
    transform: "translate(0,0)"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424C4F",
    transform: "translate(0,0)"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C4748",
    transform: "translate(0,0)"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5052",
    transform: "translate(0,0)"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454F52",
    transform: "translate(0,0)"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D4449",
    transform: "translate(0,0)"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43494D",
    transform: "translate(0,0)"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5456",
    transform: "translate(0,0)"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40494C",
    transform: "translate(0,0)"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#565B5C",
    transform: "translate(0,0)"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525856",
    transform: "translate(0,0)"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5153",
    transform: "translate(0,0)"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515A5A",
    transform: "translate(0,0)"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F4549",
    transform: "translate(0,0)"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5353",
    transform: "translate(0,0)"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F54",
    transform: "translate(0,0)"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#50525A",
    transform: "translate(0,0)"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#50575C",
    transform: "translate(0,0)"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40474E",
    transform: "translate(0,0)"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F464C",
    transform: "translate(0,0)"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5151",
    transform: "translate(0,0)"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434B4B",
    transform: "translate(0,0)"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40474C",
    transform: "translate(0,0)"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414B4D",
    transform: "translate(0,0)"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43494A",
    transform: "translate(0,0)"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474D4E",
    transform: "translate(0,0)"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#44474C",
    transform: "translate(0,0)"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#394147",
    transform: "translate(0,0)"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5054",
    transform: "translate(0,0)"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41494B",
    transform: "translate(0,0)"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D4647",
    transform: "translate(0,0)"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#46484A",
    transform: "translate(0,0)"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5052",
    transform: "translate(0,0)"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444A4C",
    transform: "translate(0,0)"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5152",
    transform: "translate(0,0)"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495153",
    transform: "translate(0,0)"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#48504F",
    transform: "translate(0,0)"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F474C",
    transform: "translate(0,0)"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505557",
    transform: "translate(0,0)"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F474A",
    transform: "translate(0,0)"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4F51",
    transform: "translate(0,0)"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494E52",
    transform: "translate(0,0)"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495153",
    transform: "translate(0,0)"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434A4B",
    transform: "translate(0,0)"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464F50",
    transform: "translate(0,0)"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5253",
    transform: "translate(0,0)"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#43474D",
    transform: "translate(0,0)"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515353",
    transform: "translate(0,0)"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5255",
    transform: "translate(0,0)"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424B4D",
    transform: "translate(0,0)"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495052",
    transform: "translate(0,0)"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454E4E",
    transform: "translate(0,0)"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464E50",
    transform: "translate(0,0)"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F4849",
    transform: "translate(0,0)"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41474B",
    transform: "translate(0,0)"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454D4F",
    transform: "translate(0,0)"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#46484A",
    transform: "translate(0,0)"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474B4C",
    transform: "translate(0,0)"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484D52",
    transform: "translate(0,0)"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5153",
    transform: "translate(0,0)"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F51",
    transform: "translate(0,0)"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#434A4D",
    transform: "translate(0,0)"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5053",
    transform: "translate(0,0)"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4C4D",
    transform: "translate(0,0)"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525757",
    transform: "translate(0,0)"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484E52",
    transform: "translate(0,0)"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41494E",
    transform: "translate(0,0)"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495051",
    transform: "translate(0,0)"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C4F",
    transform: "translate(0,0)"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41484D",
    transform: "translate(0,0)"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424B4F",
    transform: "translate(0,0)"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5152",
    transform: "translate(0,0)"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414C4E",
    transform: "translate(0,0)"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5154",
    transform: "translate(0,0)"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#41494A",
    transform: "translate(0,0)"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454D4E",
    transform: "translate(0,0)"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5052",
    transform: "translate(0,0)"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#424A4E",
    transform: "translate(0,0)"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454F4F",
    transform: "translate(0,0)"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5053",
    transform: "translate(0,0)"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494B4F",
    transform: "translate(0,0)"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F4F",
    transform: "translate(0,0)"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A4E54",
    transform: "translate(0,0)"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40474A",
    transform: "translate(0,0)"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#364041",
    transform: "translate(0,0)"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494F51",
    transform: "translate(0,0)"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#444C4D",
    transform: "translate(0,0)"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414647",
    transform: "translate(0,0)"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454D50",
    transform: "translate(0,0)"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5155",
    transform: "translate(0,0)"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5252",
    transform: "translate(0,0)"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F52",
    transform: "translate(0,0)"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5053",
    transform: "translate(0,0)"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A5153",
    transform: "translate(0,0)"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484B4D",
    transform: "translate(0,0)"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464F51",
    transform: "translate(0,0)"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464C52",
    transform: "translate(0,0)"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484D50",
    transform: "translate(0,0)"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5051",
    transform: "translate(0,0)"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5256",
    transform: "translate(0,0)"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D4F4E",
    transform: "translate(0,0)"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454C53",
    transform: "translate(0,0)"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464E4F",
    transform: "translate(0,0)"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474E52",
    transform: "translate(0,0)"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F50",
    transform: "translate(0,0)"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464E51",
    transform: "translate(0,0)"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484D4F",
    transform: "translate(0,0)"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#484F50",
    transform: "translate(0,0)"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4E53",
    transform: "translate(0,0)"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5050",
    transform: "translate(0,0)"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464B4F",
    transform: "translate(0,0)"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C5252",
    transform: "translate(0,0)"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4A504F",
    transform: "translate(0,0)"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5254",
    transform: "translate(0,0)"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495152",
    transform: "translate(0,0)"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5053",
    transform: "translate(0,0)"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5051",
    transform: "translate(0,0)"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#485053",
    transform: "translate(0,0)"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#495052",
    transform: "translate(0,0)"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#42484A",
    transform: "translate(0,0)"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5354",
    transform: "translate(0,0)"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#465050",
    transform: "translate(0,0)"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B5455",
    transform: "translate(0,0)"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5456",
    transform: "translate(0,0)"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#505455",
    transform: "translate(0,0)"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5253",
    transform: "translate(0,0)"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5455",
    transform: "translate(0,0)"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4D5355",
    transform: "translate(0,0)"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5458",
    transform: "translate(0,0)"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5354",
    transform: "translate(0,0)"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E5355",
    transform: "translate(0,0)"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5556",
    transform: "translate(0,0)"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494B4B",
    transform: "translate(0,0)"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4C4B",
    transform: "translate(0,0)"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4F4E",
    transform: "translate(0,0)"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#51504F",
    transform: "translate(0,0)"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#555657",
    transform: "translate(0,0)"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#535454",
    transform: "translate(0,0)"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4C4C",
    transform: "translate(0,0)"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F5150",
    transform: "translate(0,0)"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#515150",
    transform: "translate(0,0)"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#525253",
    transform: "translate(0,0)"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#565756",
    transform: "translate(0,0)"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#535353",
    transform: "translate(0,0)"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494A49",
    transform: "translate(0,0)"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4E4E4C",
    transform: "translate(0,0)"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4E4E",
    transform: "translate(0,0)"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4B4B",
    transform: "translate(0,0)"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4C4D",
    transform: "translate(0,0)"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4A48",
    transform: "translate(0,0)"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#545555",
    transform: "translate(0,0)"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#535253",
    transform: "translate(0,0)"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4B4A4B",
    transform: "translate(0,0)"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4C4B4C",
    transform: "translate(0,0)"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#535454",
    transform: "translate(0,0)"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4E4F",
    transform: "translate(0,0)"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#4F4E4E",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaspIcon);
export default __webpack_public_path__ + "static/media/wasp_icon.d8492da53416c06178448e2d217c5a0c.svg";
export { ForwardRef as ReactComponent };